// eslint-disable block-scoped-var, no-redeclare, no-control-regex, no-prototype-builtins
// tslint:disable
/**
 * This file is generated. Do not edit manually
 */
"use strict";
import * as $protobuf from "protobufjs/light";
var $root = $protobuf.roots.proto || ($protobuf.roots.proto = new $protobuf.Root());
$root.addJSON({
    CommandCode: {
        values: {
            Undefined: 0,
            Register: 1,
            Login: 2,
            ChoosePlayerName: 3,
            DisconnectPlayer: 4,
            RefreshCache: 6,
            Ping: 7,
            FacebookConnectInfo: 20,
            FacebookConnect: 21,
            FacebookFriendInfo: 22,
            GoogleConnectInfo: 23,
            GoogleConnect: 24,
            AmazonConnectInfo: 26,
            AmazonConnect: 27,
            DeviceConnect: 28,
            EmailConnect: 29,
            EmailConnectInfo: 30,
            AppleConnectInfo: 31,
            AppleConnect: 32,
            ChoosePlayerProfilePicture: 40,
            PlayerChangeSettings: 41,
            PlayerPreferencesStorage: 42,
            PlayerInfo: 50,
            FarmInfo: 51,
            InventoryInfo: 52,
            ProductionInfo: 53,
            QuestInfo: 54,
            EventInfo: 55,
            ContractInfo: 56,
            PackagePurchaseInfo: 58,
            OutskirtsInfo: 59,
            PendingInventoryInfo: 60,
            PlayerProfileInfo: 61,
            VisitOtherFarmInfo: 62,
            CafeRecipeInfo: 63,
            LimitedActionInfo: 65,
            FacebookPointsInfo: 66,
            ShiftLevelInfo: 67,
            AchievementInfo: 68,
            PaymentEntryInfo: 69,
            PlayerSettingsInfo: 70,
            SubscriptionChangeInfo: 71,
            SubscriptionInfo: 72,
            ProductionEffectItemInfo: 73,
            LoginNotificationServer: 80,
            ReloadScheduledEventsNotification: 81,
            UpcomingMaintenance: 82,
            ExpandFarmGold: 100,
            ExpandFarmResource: 101,
            StartConstructGold: 102,
            StartConstructResource: 103,
            SkipConstruct: 104,
            FinishConstruct: 105,
            StartUpgradeGold: 106,
            StartUpgradeResource: 107,
            SkipUpgrade: 108,
            FinishUpgrade: 109,
            Demolish: 110,
            MoveBuilding: 111,
            StoreBuilding: 112,
            UnstoreBuilding: 113,
            BuyFarmImprovement: 114,
            PvpMapAttack: 130,
            PvpMapInfo: 131,
            PvpMapJoin: 132,
            PvpMapNotification: 133,
            PvpMapReinforce: 134,
            PvpLeagueInfo: 135,
            PvpLeagueRanking: 136,
            CreateCoop: 150,
            UpdateCoop: 151,
            JoinCoop: 152,
            LeaveCoop: 153,
            KickCoopMember: 154,
            AssignCoopMemberRole: 155,
            SendCoopPoints: 156,
            CollectCoopPoints: 157,
            UpdateCoopProject: 158,
            SearchCoop: 159,
            JoinableCoopList: 160,
            StartCoopProject: 161,
            StopCoopProject: 162,
            DonateToCoop: 163,
            BuyCoopImprovement: 164,
            BuyCoopBuff: 165,
            CoopInvitePlayer: 195,
            CoopCancelInvite: 196,
            CoopInviteInfo: 197,
            PlayerInviteInfo: 198,
            PlayerCancelInvite: 199,
            CoopInfo: 201,
            CoopPointsInfo: 202,
            CoopMemberInfo: 203,
            KickedCoopMemberInfo: 204,
            CoopProjectTypeInfo: 205,
            CoopProjectInfo: 206,
            CoopInventoryInfo: 207,
            CoopImprovementInfo: 208,
            CoopBuffInfo: 209,
            CoopMessageInfo: 211,
            InboxInfo: 230,
            ReadInboxItem: 231,
            CollectInBoxItemAttachments: 232,
            DeleteInboxItem: 233,
            InboxUpdateNotification: 234,
            StartProduce: 250,
            BoostProduce: 251,
            SkipProduce: 252,
            CollectProducts: 253,
            SellProducts: 254,
            BuyProducts: 255,
            BuyProductsGold: 256,
            DonateResource: 257,
            CancelProduction: 258,
            FulfillContract: 275,
            DismissContract: 276,
            SkipContract: 277,
            QuestStart: 285,
            QuestUpdate: 286,
            QuestFinish: 287,
            SkipQuestTask: 288,
            CompleteQuestState: 289,
            PaymentPackageList: 300,
            VerifyPaymentReceipt: 301,
            OpenTransactionList: 302,
            FinishTransaction: 303,
            WebShopCatalog: 304,
            WebShopCheckout: 305,
            UpdatePaymentEntry: 306,
            MapPlayerSubscription: 307,
            VerifySubscriptionReceipt: 308,
            BuyPackage: 310,
            ConsumePackage: 311,
            ConsumePendingInventory: 312,
            BuyDogPackage: 313,
            ConsumeDogPackageBonus: 314,
            ConsumeUnlockedPackage: 315,
            UnlockedPackageInfo: 316,
            UnlockLoginPackage: 317,
            OfferCharacteristicsList: 320,
            BalloonInfo: 330,
            ConsumeBalloon: 331,
            PopBalloon: 332,
            GrantReward: 340,
            GrantCoopReward: 341,
            SendAndCollectFacebookPoints: 342,
            CollectCollectablePointReward: 343,
            CollectedPointRewardInfo: 344,
            UpgradeOutskirt: 350,
            BuyLibraryImprovement: 351,
            BuyMarketImprovement: 352,
            CollectWater: 353,
            ProduceAndCollectOutskirt: 355,
            StartFarmMachine: 358,
            ExchangeFreeTreatPoints: 359,
            CatchFish: 360,
            SellFish: 361,
            BuyPierImprovement: 363,
            CookFish: 364,
            SkipCooking: 365,
            CollectFishFilet: 366,
            CookingPansInfo: 367,
            PlayerLeagueInfo: 411,
            PlayerLeagueRanking: 412,
            CoopLeagueInfo: 413,
            CoopLeagueRanking: 414,
            CollectLeagueInfo: 415,
            CollectLeagueRanking: 416,
            ThemedEventStart: 430,
            ThemedEventFinish: 431,
            UpdateLeagueEvent: 432,
            UpdateCoopLeagueEvent: 433,
            TemporaryFarmStart: 434,
            UpdateCollectLeagueEvent: 435,
            UpdatePurchasePointEvent: 436,
            PurchasePointInfo: 437,
            TraderInfo: 438,
            UpdateTraderEvent: 439,
            StartQuestTreeEvent: 440,
            CollectLoginReward: 441,
            FortuneTellerInfo: 442,
            LoginEventInfo: 443,
            UpdateLongTermPointEvent: 444,
            LongTermPointEventInfo: 445,
            LongTermPointEventRankInfo: 446,
            UpdatePvpLeagueEvent: 447,
            LoginChatServer: 451,
            GetChatRoom: 452,
            PostInChatRoom: 453,
            NewMessageInChatRoomNotice: 454,
            ServerLogin: 490,
            ServerExecuteCommand: 491,
            ServerDispatchResponse: 492,
            AddResourceCheat: 500,
            AddBuildingCheat: 501,
            AddXpCheat: 502,
            AddOutskirtXpCheat: 503,
            AddCoopXpCheat: 504,
            UpdateQuestTasksCheat: 506,
            NextOffersCheat: 507,
            SubscriptionCheat: 508,
            UpdateShiftLevelCheat: 509,
            SubscriptionLevelCheat: 510,
            AddCoopProjectCompletionsCheat: 512,
            AssignCoopMemberRoleCheat: 513,
            CollectProductsCheat: 514,
            UpdatePlayerLeagueCheat: 515,
            UpdateCoopLeagueCheat: 516,
            AddAdventurerXpCheat: 517,
            LastLoginCheat: 518,
            ResetBalloonOfferCheat: 519,
            UpdateCollectLeagueCheat: 520,
            WebPaymentCheat: 521,
            AddCoopResourceCheat: 522,
            AdjustCoopProjectTimeCheat: 523,
            ResetLimitedActionsCheat: 524,
            UpdatePurchasePointCheat: 525,
            AdjustUnlockPackageTimeCheat: 526,
            AdjustCookingTimeCheat: 527,
            UpdateLoginEventCheat: 528,
            UpdateCoopMemberJoinTimeCheat: 529,
            UpdateLongTermPointEventCheat: 530,
            UpdateEventScheduleCheat: 531,
            ClientIpCheat: 532,
            AddPvpUnitsCheat: 533,
            AddPvpEnergyCheat: 534,
            UpdatePvpEventPointsCheat: 535,
            AddBuildingSlotCheat: 536,
        },
    },
    Request: {
        fields: {
            sequenceNumber: {
                type: "int32",
                id: 2,
            },
            data: {
                type: "bytes",
                id: 3,
            },
        },
    },
    Response: {
        fields: {
            sequenceNumber: {
                type: "int32",
                id: 2,
            },
            statusCode: {
                type: "StatusCode",
                id: 3,
            },
            data: {
                type: "bytes",
                id: 4,
            },
        },
    },
    StatusCode: {
        values: {
            Undefined: 0,
            OK: 200,
            DEVICE_INVALID: 100,
            DEVICE_ALREADY_REGISTERED: 101,
            ACCESS_TOKEN_ERROR: 102,
            DISCONNECT_BY_LOGIN: 103,
            BANNED: 104,
            INVALID_PLATFORM_TYPE: 105,
            INVALID_DEVICE_TYPE: 106,
            INVALID_EMAIL: 107,
            INVALID_PASSWORD: 108,
            INVALID_PASSWORD_LENGTH: 109,
            INVALID_PASSWORD_FORMAT: 110,
            INVALID_EMAIL_FORMAT: 111,
            PROCESSING_PENDING: 300,
            ACCESS_DENIED: 403,
            INVALID_ACTION: 405,
            NO_PERMISSION: 406,
            INVALID_BUSINESS_TERMS: 407,
            INVALID_IDS: 410,
            INVALID_COOP_ID: 411,
            INVALID_PLAYER_ID: 412,
            INVALID_FARM_ID: 413,
            INVALID_EXPANSION_ID: 414,
            INVALID_BUILDING_ID: 415,
            INVALID_ITEM_ID: 416,
            INVALID_PACKAGE_ID: 417,
            INVALID_TRANSFER_ID: 418,
            INVALID_QUEST_ID: 419,
            INVALID_RECIPE_ID: 420,
            INVALID_PRODUCTION_ID: 421,
            INVALID_CONTRACT_ID: 422,
            INVALID_RESEARCH_ID: 423,
            INVALID_IMPROVEMENT_ID: 424,
            INVALID_OUTSKIRT_ID: 425,
            INVALID_EVENT_ID: 426,
            INVALID_PROJECT_ID: 427,
            INVALID_BALLOON_ID: 428,
            INVALID_COOKING_PAN_ID: 429,
            INVALID_PROJECT_STATE: 430,
            INVALID_BUILDING_STATE: 431,
            INVALID_PRODUCTION_STATE: 432,
            INVALID_QUEST_STATE: 433,
            INVALID_EVENT_STATE: 434,
            INVALID_CONTRACT_STATE: 435,
            INVALID_SHIP_STATE: 436,
            INVALID_MISSION_STATE: 437,
            INVALID_DATA: 440,
            INVALID_AMOUNT: 441,
            INVALID_POSITION: 442,
            INVALID_ROTATION: 443,
            INVALID_LEVEL: 444,
            INVALID_COOP_LEVEL: 445,
            INVALID_DESCRIPTION: 446,
            INVALID_INTERNAL_NOTICE: 447,
            INVALID_REWARD_ID: 448,
            NOT_ENOUGH_RESOURCES: 450,
            NOT_ENOUGH_WORKERS: 451,
            NO_FREE_BUILD_SLOT: 452,
            LIMIT_REACHED: 453,
            STORAGE_LIMIT_REACHED: 454,
            BUILDING_LIMIT_REACHED: 455,
            CHAT_USER_NOT_EXISTING: 456,
            PACKAGE_PURCHASE_MAX_REACHED: 457,
            PAN_IN_USE: 458,
            PAN_IS_LOCKED: 459,
            NAME_INVALID: 460,
            NAME_IN_USE: 461,
            BAD_WORD: 462,
            BAD_WORD_IN_SECOND_FIELD: 463,
            INTERNAL_SERVER_ERROR: 500,
            NOT_IMPLEMENTED: 501,
            SERVICE_UNAVAILABLE: 503,
            INVALID_VERSION: 505,
        },
    },
    ItemType: {
        values: {
            CURRENCY_TYPE: 0,
            GOOD_TYPE: 1,
            BUILDING_TYPE: 2,
            PACKAGE_TYPE: 3,
            PROFILE_PICTURE_TYPE: 4,
            PVP_UNIT_TYPE: 5,
        },
    },
    BuildingStateType: {
        values: {
            IDLE: 0,
            CONSTRUCTING: 1,
            UPGRADING: 2,
            DEMOLISHING: 3,
        },
    },
    BuffHierarchyType: {
        values: {
            ALLIANCE: 0,
            PLAYER: 1,
            FARM: 2,
            BUILDING_CATEGORY: 3,
            BUILDING_GROUP: 4,
            BUILDING: 5,
        },
    },
    BuffContextType: {
        values: {
            ANY_CONTEXT: 0,
            PRODUCTION: 1,
            CONSTRUCTION: 2,
            EXPANSION: 3,
            TRADE: 4,
            MISSION: 5,
            EVENT: 6,
            CONTRACT: 7,
            CAFE: 8,
            PROJECT: 9,
            FISH: 10,
            OFFER: 11,
        },
    },
    BuffTargetType: {
        values: {
            ANY_TARGET: 0,
            TIME: 1,
            COST: 2,
            PRODUCT: 3,
            REVENUE: 4,
            XP: 5,
            FAME: 6,
            MARKET_XP: 7,
            ADVENTURER_XP: 8,
            HAPPINESS: 9,
            SATISFACTION: 10,
            POINTS: 11,
            FISHING_XP: 12,
            HIT_AREA: 13,
        },
    },
    QuestStateType: {
        values: {
            OPEN: 0,
            PROGRESS: 1,
            COMPLETE: 2,
            REWARDED: 3,
            REMOVED: 4,
        },
    },
    CoopJoinPolicyType: {
        values: {
            JOINABLE: 0,
            BY_INVITATION: 1,
            CLOSED: 2,
        },
    },
    CoopMemberRoleType: {
        values: {
            LEADER: 0,
            DEPUTY: 1,
            MEMBER: 2,
            CANDIDATE: 3,
        },
    },
    LimitedActionType: {
        values: {
            DOGHOUSE: 0,
            DOGHOUSE_AD: 1,
            WATER_TOWER: 2,
            CONTRACT_SKIP_AD: 3,
            CONTRACT_AD: 4,
            CATCH: 5,
            FACEBOOK_POINTS: 6,
            LOYALTY_POINTS: 7,
        },
    },
    LimitedActionResetType: {
        values: {
            DAILY_BASE: 0,
            ON_ACTION: 1,
            NO_RESET: 2,
        },
    },
    PendingInventoryType: {
        values: {
            ANY_SOURCE: 0,
            SYSTEM: 1,
            PLAYER_LEAGUE_RANKING: 10,
            PLAYER_LEAGUE_POINTS_1: 11,
            PLAYER_LEAGUE_POINTS_2: 12,
            PLAYER_LEAGUE_POINTS_3: 13,
            PLAYER_LEAGUE_POINTS_4: 14,
            PLAYER_LEAGUE_POINTS_5: 15,
            PLAYER_LEAGUE_POINTS_6: 16,
            COOP_LEAGUE_RANKING: 20,
            COOP_LEAGUE_POINTS_1: 21,
            COOP_LEAGUE_POINTS_2: 22,
            COOP_LEAGUE_POINTS_3: 23,
            COOP_LEAGUE_POINTS_4: 24,
            COOP_LEAGUE_POINTS_5: 25,
            COOP_LEAGUE_POINTS_6: 26,
            WELCOME_BACK_PACKAGE: 30,
            SONY_GIFT: 31,
            CAFE_CELEBRATION_GIFT: 32,
            SKY_LAUNCH_GIFT: 33,
            FACEBOOK_INVITEE: 34,
            FACEBOOK_INVITER: 35,
            BIRTHDAY_GIFT: 36,
            TRADER_EVEENT_FULFILLED: 37,
            ANNIVERSARY_GIFT: 38,
            CUSTOMER_POINTS_1: 41,
            CUSTOMER_POINTS_2: 42,
            CUSTOMER_POINTS_3: 43,
            CUSTOMER_POINTS_4: 44,
            CUSTOMER_POINTS_5: 45,
            CUSTOMER_POINTS_6: 46,
            COLLECT_LEAGUE_RANKING: 50,
            COLLECT_LEAGUE_POINTS_1: 51,
            COLLECT_LEAGUE_POINTS_2: 52,
            COLLECT_LEAGUE_POINTS_3: 53,
            COLLECT_LEAGUE_POINTS_4: 54,
            COLLECT_LEAGUE_POINTS_5: 55,
            COLLECT_LEAGUE_POINTS_6: 56,
            PURCHASE_POINT_EVENT_POINTS_1: 61,
            PURCHASE_POINT_EVENT_POINTS_2: 62,
            PURCHASE_POINT_EVENT_POINTS_3: 63,
            PURCHASE_POINT_EVENT_POINTS_4: 64,
            PURCHASE_POINT_EVENT_POINTS_5: 65,
            PURCHASE_POINT_EVENT_POINTS_6: 66,
            LONG_TERM_POINT_EVENT_RANKING: 70,
            LONG_TERM_POINT_EVENT_POINTS_1: 71,
            LONG_TERM_POINT_EVENT_POINTS_2: 72,
            LONG_TERM_POINT_EVENT_POINTS_3: 73,
            LONG_TERM_POINT_EVENT_POINTS_4: 74,
            LONG_TERM_POINT_EVENT_POINTS_5: 75,
            LONG_TERM_POINT_EVENT_POINTS_6: 76,
            PVP_EVENT_RANKING: 80,
            PVP_EVENT_POINTS_1: 81,
            PVP_EVENT_POINTS_2: 82,
            PVP_EVENT_POINTS_3: 83,
            PVP_EVENT_POINTS_4: 84,
            PVP_EVENT_POINTS_5: 85,
            PVP_EVENT_POINTS_6: 86,
        },
    },
    RewardSource: {
        values: {
            Undefined: 0,
            PURCHASE_OFFER: 1,
            PACKAGE: 2,
            MISSING_RESOURCES: 3,
            HYDRA: 4,
            BALLOON: 5,
            BONUS: 6,
            POINT_REWARD: 7,
        },
    },
    AchievementContext: {
        values: {
            UNKNOWN: 0,
            FISH_CATCH: 1,
        },
    },
    CoopMessageType: {
        values: {
            COOP_UNDEFINED: 0,
            COOP_PROJECT_STARTED: 1,
            COOP_PROJECT_COMPLETED: 2,
            COOP_PROJECT_STOPPED: 3,
            COOP_PROJECT_FAILED: 4,
            COOP_LEVELED_UP: 5,
            COOP_PLAYER_JOINED: 6,
            COOP_INVITED_PLAYER_JOINED: 7,
            COOP_PLAYER_LEFT: 8,
            COOP_PLAYER_KICKED: 9,
            COOP_PLAYER_RANK_CHANGED: 10,
            COOP_PLAYER_LEADERSHIP: 11,
            COOP_PLAYER_DONATED: 12,
            COOP_IMPROVEMENT_UPGRADE: 13,
            COOP_BUFF_ACTIVATED: 14,
        },
    },
    PlayerPreferencesPlatformType: {
        values: {
            PLAT_UNKNOWN: 0,
            PLAT_SHARED: 1,
            PLAT_WEB: 2,
            PLAT_MOBILE: 3,
        },
    },
    Shop: {
        values: {
            GOOGLEPLAY: 0,
            APPSTORE: 1,
            SUPPORT: 1000,
        },
    },
    SubscriptionUpdateEvent: {
        values: {
            SUBSCRIPTION_RECOVERED: 0,
            SUBSCRIPTION_RENEWED: 1,
            SUBSCRIPTION_CANCELED: 2,
            SUBSCRIPTION_PURCHASED: 3,
            SUBSCRIPTION_ON_HOLD: 4,
            SUBSCRIPTION_IN_GRACE_PERIOD: 5,
            SUBSCRIPTION_RESTARTED: 6,
            SUBSCRIPTION_PRICE_CHANGE_CONFIRMED: 7,
            SUBSCRIPTION_DEFERRED: 8,
            SUBSCRIPTION_REVOKED: 9,
            SUBSCRIPTION_EXPIRED: 10,
            SUBSCRIPTION_IOS_INITIAL_BUY: 11,
            SUBSCRIPTION_IOS_RENEWED: 12,
            SUBSCRIPTION_IOS_STOP: 13,
            SUBSCRIPTION_IOS_CANCEL: 14,
        },
    },
    PointRewardType: {
        values: {
            NORMAL: 0,
            SEASON_PASS: 1,
        },
    },
    UnlockedPackageType: {
        values: {
            LOGIN_BONUS: 0,
            SUBSCRIPTION: 1,
        },
    },
    ItemParam: {
        fields: {
            typeId: {
                type: "int32",
                id: 1,
            },
            amount: {
                type: "int64",
                id: 2,
            },
            stageId: {
                type: "int32",
                id: 3,
            },
            category: {
                type: "ItemType",
                id: 4,
            },
        },
    },
    PendingInventoryParam: {
        fields: {
            transferId: {
                type: "int64",
                id: 1,
            },
            typeId: {
                type: "int32",
                id: 2,
            },
            sourceId: {
                type: "int32",
                id: 3,
            },
            creationTime: {
                type: "int32",
                id: 4,
            },
            resource: {
                rule: "repeated",
                type: "ItemParam",
                id: 5,
            },
            building: {
                rule: "repeated",
                type: "ItemParam",
                id: 6,
            },
            package: {
                rule: "repeated",
                type: "ItemParam",
                id: 7,
            },
            picture: {
                rule: "repeated",
                type: "ItemParam",
                id: 8,
            },
        },
    },
    PositionParam: {
        fields: {
            x: {
                type: "int32",
                id: 1,
            },
            y: {
                type: "int32",
                id: 2,
            },
        },
    },
    BuffParam: {
        fields: {
            id: {
                type: "int32",
                id: 1,
            },
            hierarchy: {
                type: "BuffHierarchyType",
                id: 2,
            },
            hierarchyId: {
                type: "int32",
                id: 3,
            },
            context: {
                type: "BuffContextType",
                id: 4,
            },
            target: {
                type: "BuffTargetType",
                id: 5,
            },
            targetId: {
                type: "int32",
                id: 6,
            },
            addition: {
                type: "double",
                id: 7,
            },
            factorAddition: {
                type: "double",
                id: 8,
            },
            factorMultiplication: {
                type: "double",
                id: 9,
            },
            onTop: {
                type: "double",
                id: 10,
            },
            typeId: {
                type: "int32",
                id: 11,
            },
            remainingTime: {
                type: "int32",
                id: 12,
            },
            factorAdditionMultiplication: {
                type: "double",
                id: 13,
            },
            factorAdditionMultiplicationTarget: {
                type: "double",
                id: 14,
            },
        },
    },
    BuildingParam: {
        fields: {
            id: {
                type: "int32",
                id: 1,
            },
            typeId: {
                type: "int32",
                id: 2,
            },
            stage: {
                type: "int32",
                id: 3,
            },
            posX: {
                type: "int32",
                id: 4,
            },
            posY: {
                type: "int32",
                id: 5,
            },
            flipped: {
                type: "bool",
                id: 6,
            },
            state: {
                type: "BuildingStateType",
                id: 7,
            },
            remainingTime: {
                type: "int32",
                id: 8,
            },
            recipeId: {
                type: "int32",
                id: 9,
            },
            boosterId: {
                type: "int32",
                id: 10,
            },
            amount: {
                type: "int32",
                id: 11,
            },
        },
    },
    XpParam: {
        fields: {
            xp: {
                type: "int64",
                id: 1,
            },
            level: {
                type: "int32",
                id: 2,
            },
        },
    },
    ProductionParam: {
        fields: {
            farmId: {
                type: "int32",
                id: 1,
            },
            buildingId: {
                type: "int32",
                id: 2,
            },
            recipeId: {
                type: "int32",
                id: 3,
            },
            boosterId: {
                type: "int32",
                id: 4,
            },
            amount: {
                type: "int32",
                id: 5,
            },
            remainingTime: {
                type: "int32",
                id: 6,
            },
            effectItemIds: {
                rule: "repeated",
                type: "int32",
                id: 7,
            },
        },
    },
    ContractParam: {
        fields: {
            contractId: {
                type: "int32",
                id: 1,
            },
            visualId: {
                type: "int32",
                id: 2,
            },
            remainingTime: {
                type: "int32",
                id: 3,
            },
            rewardId: {
                type: "int32",
                id: 4,
            },
            orderId: {
                rule: "repeated",
                type: "int32",
                id: 5,
            },
        },
    },
    CafeRecipeParam: {
        fields: {
            recipeId: {
                type: "int32",
                id: 1,
            },
            usages: {
                type: "int32",
                id: 2,
            },
        },
    },
    EventParam: {
        fields: {
            eventId: {
                type: "int32",
                id: 1,
            },
            typeId: {
                type: "int32",
                id: 2,
            },
            startTime: {
                type: "int32",
                id: 3,
            },
            duration: {
                type: "int32",
                id: 4,
            },
            player: {
                type: "PlayerEventParam",
                id: 5,
            },
            maxDifficulty: {
                type: "int32",
                id: 6,
            },
            rewardId: {
                type: "int32",
                id: 7,
            },
        },
    },
    PlayerEventParam: {
        fields: {
            difficulty: {
                type: "int32",
                id: 1,
            },
            finished: {
                type: "bool",
                id: 2,
            },
        },
    },
    FarmEventParam: {
        fields: {
            eventId: {
                type: "int32",
                id: 1,
            },
            typeId: {
                type: "int32",
                id: 2,
            },
            startTime: {
                type: "int32",
                id: 3,
            },
            duration: {
                type: "int32",
                id: 4,
            },
            farmCreated: {
                type: "bool",
                id: 5,
            },
        },
    },
    CustomerEventParam: {
        fields: {
            eventId: {
                type: "int32",
                id: 1,
            },
            typeId: {
                type: "int32",
                id: 2,
            },
            startTime: {
                type: "int32",
                id: 3,
            },
            duration: {
                type: "int32",
                id: 4,
            },
            difficulty: {
                type: "int32",
                id: 5,
            },
            customerId: {
                type: "int32",
                id: 6,
            },
            satisfaction: {
                type: "int32",
                id: 7,
            },
        },
    },
    TradeParam: {
        fields: {
            offerId: {
                type: "int32",
                id: 1,
            },
            boughtAmount: {
                type: "int32",
                id: 2,
            },
            maxPurchases: {
                type: "int32",
                id: 3,
            },
            cost: {
                rule: "repeated",
                type: "ItemParam",
                id: 4,
            },
            reward: {
                rule: "repeated",
                type: "ResourceRewardParam",
                id: 5,
            },
            discount: {
                type: "int32",
                id: 6,
            },
        },
    },
    QuestParam: {
        fields: {
            questId: {
                type: "int32",
                id: 1,
            },
            state: {
                type: "QuestStateType",
                id: 3,
            },
            task: {
                rule: "repeated",
                type: "QuestTaskParam",
                id: 4,
            },
            hasRemainingTime: {
                type: "bool",
                id: 5,
            },
            remainingTime: {
                type: "int32",
                id: 6,
            },
        },
    },
    QuestTaskParam: {
        fields: {
            index: {
                type: "int32",
                id: 1,
            },
            itemId: {
                type: "int32",
                id: 2,
            },
            amount: {
                type: "int32",
                id: 3,
            },
        },
    },
    RankingParam: {
        fields: {
            rank: {
                type: "int32",
                id: 1,
            },
            rankValue: {
                type: "int64",
                id: 2,
            },
            id: {
                type: "int64",
                id: 3,
            },
            name: {
                type: "string",
                id: 4,
            },
            profilePictureId: {
                type: "int32",
                id: 5,
            },
        },
    },
    ResourceRewardParam: {
        fields: {
            id: {
                type: "int32",
                id: 1,
            },
            amount: {
                type: "int64",
                id: 2,
            },
        },
    },
    BuildingRewardParam: {
        fields: {
            id: {
                type: "int32",
                id: 1,
            },
            amount: {
                type: "int64",
                id: 2,
            },
            stageId: {
                type: "int32",
                id: 3,
            },
        },
    },
    PackageRewardParam: {
        fields: {
            id: {
                type: "int32",
                id: 1,
            },
            amount: {
                type: "int64",
                id: 2,
            },
        },
    },
    ProfilePictureRewardParam: {
        fields: {
            id: {
                type: "int32",
                id: 1,
            },
            amount: {
                type: "int64",
                id: 2,
            },
        },
    },
    RandomPoolRewardParam: {
        fields: {
            id: {
                type: "int32",
                id: 1,
            },
            amount: {
                type: "int64",
                id: 2,
            },
        },
    },
    UnlockableRewardParam: {
        fields: {
            id: {
                type: "int32",
                id: 1,
            },
            amount: {
                type: "int32",
                id: 2,
            },
        },
    },
    ConnectedPlayerParam: {
        fields: {
            id: {
                type: "int64",
                id: 1,
            },
            name: {
                type: "string",
                id: 2,
            },
            lastLoginTime: {
                type: "int32",
                id: 3,
            },
            xp: {
                type: "int64",
                id: 4,
            },
            level: {
                type: "int32",
                id: 5,
            },
            amountGold: {
                type: "int64",
                id: 6,
            },
            amountFarmDollars: {
                type: "int64",
                id: 7,
            },
            profilePictureId: {
                type: "int64",
                id: 8,
            },
        },
    },
    FriendPointsParam: {
        fields: {
            playerId: {
                type: "int64",
                id: 1,
            },
            name: {
                type: "string",
                id: 2,
            },
            xp: {
                type: "int64",
                id: 3,
            },
            amount: {
                type: "int64",
                id: 4,
            },
            friendId: {
                type: "string",
                id: 5,
            },
        },
    },
    CoopMemberParam: {
        fields: {
            playerId: {
                type: "int64",
                id: 1,
            },
            name: {
                type: "string",
                id: 2,
            },
            role: {
                type: "int32",
                id: 3,
            },
            xp: {
                type: "int64",
                id: 4,
            },
            xpAtJoin: {
                type: "int64",
                id: 5,
            },
            lp: {
                type: "int64",
                id: 6,
            },
            joinTime: {
                type: "int32",
                id: 7,
            },
            profilePictureId: {
                type: "int32",
                id: 8,
            },
            loginTime: {
                type: "int32",
                id: 9,
            },
            donation: {
                type: "int64",
                id: 10,
            },
            secondsUntilCoopProjectAccess: {
                type: "int32",
                id: 11,
            },
        },
    },
    CoopInviteParam: {
        fields: {
            playerId: {
                type: "int64",
                id: 1,
            },
            name: {
                type: "string",
                id: 2,
            },
            inviteTime: {
                type: "int32",
                id: 3,
            },
            hostName: {
                type: "string",
                id: 4,
            },
            coopId: {
                type: "int64",
                id: 5,
            },
        },
    },
    CoopMemberPointsParam: {
        fields: {
            playerId: {
                type: "int64",
                id: 1,
            },
            name: {
                type: "string",
                id: 2,
            },
            level: {
                type: "int32",
                id: 3,
            },
            amount: {
                type: "int64",
                id: 4,
            },
        },
    },
    CoopParam: {
        fields: {
            id: {
                type: "int64",
                id: 1,
            },
            xp: {
                type: "int64",
                id: 2,
            },
            language: {
                type: "string",
                id: 3,
            },
            memberCount: {
                type: "int32",
                id: 4,
            },
            memberLimit: {
                type: "int32",
                id: 5,
            },
            minLevel: {
                type: "int32",
                id: 6,
            },
            joinPolicy: {
                type: "int32",
                id: 7,
            },
            name: {
                type: "string",
                id: 8,
            },
            description: {
                type: "string",
                id: 9,
            },
            creationTime: {
                type: "int32",
                id: 10,
            },
            internalNotice: {
                type: "string",
                id: 11,
            },
        },
    },
    CoopProjectTypeParam: {
        fields: {
            typeId: {
                type: "int32",
                id: 1,
            },
            completions: {
                type: "int32",
                id: 2,
            },
            maxDifficulty: {
                type: "int32",
                id: 3,
            },
        },
    },
    CoopProjectParam: {
        fields: {
            projectId: {
                type: "int32",
                id: 1,
            },
            typeId: {
                type: "int32",
                id: 2,
            },
            difficulty: {
                type: "int32",
                id: 3,
            },
            completed: {
                type: "bool",
                id: 4,
            },
            remainingTime: {
                type: "int32",
                id: 5,
            },
            task: {
                rule: "repeated",
                type: "CoopProjectTaskParam",
                id: 6,
            },
        },
    },
    CoopProjectTaskParam: {
        fields: {
            itemId: {
                type: "int32",
                id: 1,
            },
            amount: {
                type: "int32",
                id: 2,
            },
        },
    },
    ResearchParam: {
        fields: {
            researchId: {
                type: "int32",
                id: 1,
            },
            level: {
                type: "int32",
                id: 2,
            },
        },
    },
    ImprovementParam: {
        fields: {
            improvementId: {
                type: "int32",
                id: 1,
            },
            level: {
                type: "int32",
                id: 2,
            },
        },
    },
    OutskirtParam: {
        fields: {
            typeId: {
                type: "int32",
                id: 1,
            },
            xp: {
                type: "int64",
                id: 2,
            },
            stage: {
                type: "int32",
                id: 3,
            },
            recipeId: {
                type: "int32",
                id: 4,
            },
            amount: {
                type: "int32",
                id: 5,
            },
            improvement: {
                rule: "repeated",
                type: "ImprovementParam",
                id: 6,
            },
        },
    },
    FacebookGiftParam: {
        fields: {
            packageId: {
                type: "int32",
                id: 1,
            },
            facebookId: {
                type: "string",
                id: 2,
            },
            info: {
                type: "string",
                id: 3,
            },
        },
    },
    FacebookFriendParam: {
        fields: {
            playerId: {
                type: "int64",
                id: 1,
            },
            name: {
                type: "string",
                id: 2,
            },
            xp: {
                type: "int64",
                id: 3,
            },
            facebookId: {
                type: "string",
                id: 4,
            },
        },
    },
    LeagueEventParam: {
        fields: {
            eventId: {
                type: "int32",
                id: 1,
            },
            typeId: {
                type: "int32",
                id: 2,
            },
            startTime: {
                type: "int32",
                id: 3,
            },
            duration: {
                type: "int32",
                id: 4,
            },
            rewardId: {
                type: "int32",
                id: 5,
            },
        },
    },
    LeagueEventProgressParam: {
        fields: {
            eventId: {
                type: "int32",
                id: 1,
            },
            leagueId: {
                type: "int32",
                id: 2,
            },
            points: {
                type: "int64",
                id: 3,
            },
        },
    },
    LeagueRankingParam: {
        fields: {
            id: {
                type: "int64",
                id: 1,
            },
            xp: {
                type: "int64",
                id: 2,
            },
            name: {
                type: "string",
                id: 3,
            },
            points: {
                type: "int64",
                id: 4,
            },
            profilePictureId: {
                type: "int32",
                id: 5,
            },
        },
    },
    LongTermPointEventParam: {
        fields: {
            eventParam: {
                type: "LeagueEventParam",
                id: 1,
            },
            rankingRewards: {
                rule: "repeated",
                type: "LtpeRankingRewardParam",
                id: 2,
            },
            pointRewards: {
                rule: "repeated",
                type: "LtpePointRewardParam",
                id: 3,
            },
        },
    },
    LtpeRankingRewardParam: {
        fields: {
            requiredRank: {
                type: "int32",
                id: 1,
            },
            rewards: {
                rule: "repeated",
                type: "ItemParam",
                id: 2,
            },
        },
    },
    LtpePointRewardParam: {
        fields: {
            pointRewardId: {
                type: "int32",
                id: 1,
            },
            collectableRewardId: {
                type: "int32",
                id: 2,
            },
            requiredThreshold: {
                type: "int32",
                id: 3,
            },
            resourceRewards: {
                rule: "repeated",
                type: "LtpePointRewardItemParam",
                id: 4,
            },
            seasonPassRewards: {
                rule: "repeated",
                type: "LtpePointRewardItemParam",
                id: 5,
            },
        },
    },
    LtpePointRewardItemParam: {
        oneofs: {
            reward: {
                oneof: ["resourceReward", "profilePictureReward", "buildingReward"],
            },
        },
        fields: {
            resourceReward: {
                type: "ItemParam",
                id: 1,
            },
            profilePictureReward: {
                type: "ItemParam",
                id: 2,
            },
            buildingReward: {
                type: "ItemParam",
                id: 3,
            },
        },
    },
    CoopMessageParam: {
        fields: {
            messageType: {
                type: "CoopMessageType",
                id: 1,
            },
            creationTime: {
                type: "int32",
                id: 2,
            },
            variable1: {
                type: "string",
                id: 3,
            },
            variable2: {
                type: "string",
                id: 4,
            },
            variable3: {
                type: "string",
                id: 5,
            },
        },
    },
    LimitedActionParam: {
        fields: {
            type: {
                type: "LimitedActionType",
                id: 1,
            },
            amount: {
                type: "int32",
                id: 2,
            },
            maxAmount: {
                type: "int32",
                id: 3,
            },
            secondsUntilReset: {
                type: "int32",
                id: 4,
            },
            resetDurationInSeconds: {
                type: "int32",
                id: 5,
            },
            resetType: {
                type: "LimitedActionResetType",
                id: 6,
            },
        },
    },
    AchievementParam: {
        fields: {
            context: {
                type: "AchievementContext",
                id: 1,
            },
            typeId: {
                type: "int32",
                id: 2,
            },
            points: {
                type: "int64",
                id: 3,
            },
            amount: {
                type: "int32",
                id: 4,
            },
        },
    },
    OfferParam: {
        fields: {
            id: {
                type: "uint32",
                id: 1,
            },
            duration: {
                type: "int32",
                id: 2,
            },
        },
    },
    WebShopPackage: {
        fields: {
            id: {
                type: "int64",
                id: 1,
            },
            price: {
                type: "int32",
                id: 2,
            },
            currencyCode: {
                type: "string",
                id: 3,
            },
            providerIds: {
                rule: "repeated",
                type: "int32",
                id: 4,
            },
            packageId: {
                type: "string",
                id: 5,
            },
        },
    },
    ShopGamePayout: {
        fields: {
            type: {
                type: "string",
                id: 1,
            },
            amount: {
                type: "int64",
                id: 2,
            },
        },
    },
    WebShopSmsPackage: {
        fields: {
            id: {
                type: "int64",
                id: 1,
            },
            price: {
                type: "int32",
                id: 2,
            },
            currencyCode: {
                type: "string",
                id: 3,
            },
            providerIds: {
                rule: "repeated",
                type: "int32",
                id: 4,
            },
            gamePayout: {
                rule: "repeated",
                type: "ShopGamePayout",
                id: 5,
            },
        },
    },
    WebShopProvider: {
        fields: {
            id: {
                type: "int32",
                id: 1,
            },
            countryCode: {
                type: "string",
                id: 2,
            },
            minAmount: {
                type: "int32",
                id: 3,
            },
            maxAmount: {
                type: "int32",
                id: 4,
            },
            type: {
                type: "string",
                id: 5,
            },
            translation: {
                type: "string",
                id: 6,
            },
        },
    },
    PlayerPreferencesParam: {
        fields: {
            platform: {
                type: "PlayerPreferencesPlatformType",
                id: 1,
            },
            key: {
                type: "string",
                id: 2,
            },
            value: {
                type: "string",
                id: 3,
            },
        },
    },
    PlayerPreferencesKeyParam: {
        fields: {
            platform: {
                type: "PlayerPreferencesPlatformType",
                id: 1,
            },
            key: {
                type: "string",
                id: 2,
            },
        },
    },
    SubscriptionParam: {
        fields: {
            orderId: {
                type: "string",
                id: 1,
            },
            typeId: {
                type: "int32",
                id: 2,
            },
            remainingSeconds: {
                type: "int32",
                id: 3,
            },
            lastUpdate: {
                type: "SubscriptionUpdateEvent",
                id: 4,
            },
            level: {
                type: "int32",
                id: 5,
            },
            removeBuffs: {
                rule: "repeated",
                type: "BuffParam",
                id: 6,
            },
            addBuffs: {
                rule: "repeated",
                type: "BuffParam",
                id: 7,
            },
        },
    },
    PanInfo: {
        fields: {
            panId: {
                type: "int32",
                id: 1,
            },
            filetRarityId: {
                type: "int32",
                id: 2,
            },
            filetAmount: {
                type: "int32",
                id: 3,
            },
            remainingSeconds: {
                type: "int32",
                id: 4,
            },
        },
    },
    PvpMapTile: {
        fields: {
            tileId: {
                type: "int32",
                id: 1,
            },
            playerId: {
                type: "int64",
                id: 2,
            },
            unitAmount: {
                type: "int64",
                id: 3,
            },
        },
    },
    PvpMapPlayerInfo: {
        fields: {
            playerId: {
                type: "int64",
                id: 1,
            },
            profilePictureId: {
                type: "int32",
                id: 2,
            },
            name: {
                type: "string",
                id: 3,
            },
            jelly: {
                type: "int64",
                id: 4,
            },
            jellyProduction: {
                type: "double",
                id: 5,
            },
            secondsSinceLastJellyCalculation: {
                type: "int32",
                id: 6,
            },
            energy: {
                type: "int32",
                id: 7,
            },
            secondsSinceLastEnergyCalculation: {
                type: "int32",
                id: 8,
            },
        },
    },
    CollectedPointReward: {
        fields: {
            collectablePointRewardId: {
                type: "int32",
                id: 1,
            },
            pointRewardType: {
                type: "PointRewardType",
                id: 2,
            },
        },
    },
    UnlockedPackage: {
        fields: {
            PackageId: {
                type: "int32",
                id: 1,
            },
            remainingSecondsLocked: {
                type: "int32",
                id: 2,
            },
            collected: {
                type: "bool",
                id: 3,
            },
            type: {
                type: "UnlockedPackageType",
                id: 4,
            },
        },
    },
    AmazonConnectRequest: {
        fields: {
            playerId: {
                type: "int64",
                id: 1,
            },
            deviceId: {
                type: "string",
                id: 2,
            },
            accessToken: {
                type: "string",
                id: 3,
            },
            playerIdToConnect: {
                type: "int64",
                id: 4,
            },
            trackingId: {
                type: "string",
                id: 5,
            },
        },
    },
    AmazonConnectResponse: {
        fields: {
            connectedPlayerId: {
                type: "int64",
                id: 1,
            },
        },
    },
    AmazonConnectInfoRequest: {
        fields: {
            playerId: {
                type: "int64",
                id: 1,
            },
            deviceId: {
                type: "string",
                id: 2,
            },
            accessToken: {
                type: "string",
                id: 3,
            },
        },
    },
    AmazonConnectInfoResponse: {
        fields: {
            connectedPlayer: {
                type: "ConnectedPlayerParam",
                id: 1,
            },
        },
    },
    AppleConnectRequest: {
        fields: {
            playerId: {
                type: "int64",
                id: 1,
            },
            deviceId: {
                type: "string",
                id: 2,
            },
            accessToken: {
                type: "string",
                id: 3,
            },
            playerIdToConnect: {
                type: "int64",
                id: 4,
            },
        },
    },
    AppleConnectResponse: {
        fields: {
            connectedPlayerId: {
                type: "int64",
                id: 1,
            },
        },
    },
    AppleConnectInfoRequest: {
        fields: {
            playerId: {
                type: "int64",
                id: 1,
            },
            deviceId: {
                type: "string",
                id: 2,
            },
            accessToken: {
                type: "string",
                id: 3,
            },
        },
    },
    AppleConnectInfoResponse: {
        fields: {
            connectedPlayer: {
                type: "ConnectedPlayerParam",
                id: 1,
            },
        },
    },
    ChoosePlayerNameRequest: {
        fields: {
            playerId: {
                type: "int64",
                id: 1,
            },
            newPlayerName: {
                type: "string",
                id: 2,
            },
            ignoreQuests: {
                type: "bool",
                id: 3,
            },
        },
    },
    ChoosePlayerNameResponse: {
        fields: {
            newPlayerName: {
                type: "string",
                id: 1,
            },
        },
    },
    DeviceConnectRequest: {
        fields: {
            playerId: {
                type: "int64",
                id: 1,
            },
            deviceId: {
                type: "string",
                id: 2,
            },
        },
    },
    DeviceConnectResponse: {
        fields: {
            connectedPlayerId: {
                type: "int64",
                id: 1,
            },
        },
    },
    DisconnectPlayerRequest: {
        fields: {
            playerId: {
                type: "int64",
                id: 1,
            },
        },
    },
    DisconnectPlayerResponse: {
        fields: {},
    },
    EmailConnectRequest: {
        fields: {
            playerId: {
                type: "int64",
                id: 1,
            },
            playerIdToConnect: {
                type: "int64",
                id: 2,
            },
            clientId: {
                type: "string",
                id: 3,
            },
            emailAddress: {
                type: "string",
                id: 4,
            },
            password: {
                type: "string",
                id: 5,
            },
        },
    },
    EmailConnectResponse: {
        fields: {
            connectedPlayerId: {
                type: "int64",
                id: 1,
            },
            authToken: {
                type: "string",
                id: 2,
            },
        },
    },
    EmailConnectInfoRequest: {
        fields: {
            playerId: {
                type: "int64",
                id: 1,
            },
            clientId: {
                type: "string",
                id: 2,
            },
            emailAddress: {
                type: "string",
                id: 3,
            },
            password: {
                type: "string",
                id: 4,
            },
            authToken: {
                type: "string",
                id: 5,
            },
        },
    },
    EmailConnectInfoResponse: {
        fields: {
            connectedPlayer: {
                type: "ConnectedPlayerParam",
                id: 1,
            },
        },
    },
    FacebookConnectRequest: {
        fields: {
            playerId: {
                type: "int64",
                id: 1,
            },
            deviceId: {
                type: "string",
                id: 2,
            },
            accessToken: {
                type: "string",
                id: 3,
            },
            playerIdToConnect: {
                type: "int64",
                id: 4,
            },
            trackingId: {
                type: "string",
                id: 5,
            },
            inviterFacebookId: {
                type: "string",
                id: 6,
            },
            authToken: {
                type: "string",
                id: 7,
            },
        },
    },
    FacebookConnectResponse: {
        fields: {
            connectedPlayerId: {
                type: "int64",
                id: 1,
            },
            inviteGift: {
                type: "FacebookGiftParam",
                id: 2,
            },
        },
    },
    FacebookConnectInfoRequest: {
        fields: {
            playerId: {
                type: "int64",
                id: 1,
            },
            deviceId: {
                type: "string",
                id: 2,
            },
            accessToken: {
                type: "string",
                id: 3,
            },
            authToken: {
                type: "string",
                id: 4,
            },
        },
    },
    FacebookConnectInfoResponse: {
        fields: {
            connectedPlayer: {
                type: "ConnectedPlayerParam",
                id: 1,
            },
            inviteGift: {
                rule: "repeated",
                type: "FacebookGiftParam",
                id: 2,
            },
        },
    },
    FacebookFriendInfoRequest: {
        fields: {
            playerId: {
                type: "int64",
                id: 1,
            },
            friendId: {
                rule: "repeated",
                type: "string",
                id: 2,
            },
        },
    },
    FacebookFriendInfoResponse: {
        fields: {
            friend: {
                rule: "repeated",
                type: "FacebookFriendParam",
                id: 1,
            },
        },
    },
    GoogleConnectRequest: {
        fields: {
            playerId: {
                type: "int64",
                id: 1,
            },
            deviceId: {
                type: "string",
                id: 2,
            },
            accessToken: {
                type: "string",
                id: 3,
            },
            playerIdToConnect: {
                type: "int64",
                id: 4,
            },
            trackingId: {
                type: "string",
                id: 5,
            },
        },
    },
    GoogleConnectResponse: {
        fields: {
            connectedPlayerId: {
                type: "int64",
                id: 1,
            },
        },
    },
    GoogleConnectInfoRequest: {
        fields: {
            playerId: {
                type: "int64",
                id: 1,
            },
            deviceId: {
                type: "string",
                id: 2,
            },
            accessToken: {
                type: "string",
                id: 3,
            },
        },
    },
    GoogleConnectInfoResponse: {
        fields: {
            connectedPlayer: {
                type: "ConnectedPlayerParam",
                id: 1,
            },
        },
    },
    LoginRequest: {
        fields: {
            clientVersion: {
                type: "int32",
                id: 1,
            },
            platformType: {
                type: "int32",
                id: 2,
            },
            deviceType: {
                type: "int32",
                id: 3,
            },
            playerId: {
                type: "int64",
                id: 4,
            },
            deviceId: {
                type: "string",
                id: 5,
            },
            trackingId: {
                type: "string",
                id: 6,
            },
            acceptBusinessTerms: {
                type: "bool",
                id: 7,
            },
            authToken: {
                type: "string",
                id: 8,
            },
            advertisingId: {
                type: "string",
                id: 9,
            },
        },
    },
    LoginResponse: {
        fields: {
            playerId: {
                type: "int64",
                id: 1,
            },
            remainingBanTime: {
                type: "int32",
                id: 2,
            },
            balancingXmlVersion: {
                type: "int32",
                id: 3,
            },
            assetVersion: {
                type: "int32",
                id: 4,
            },
            eventVersion: {
                type: "int32",
                id: 5,
            },
            authToken: {
                type: "string",
                id: 6,
            },
        },
    },
    PingRequest: {
        fields: {},
    },
    PingResponse: {
        fields: {},
    },
    RefreshCacheRequest: {
        fields: {
            playerId: {
                type: "int64",
                id: 1,
            },
        },
    },
    RefreshCacheResponse: {
        fields: {},
    },
    RegisterRequest: {
        fields: {
            clientVersion: {
                type: "int32",
                id: 1,
            },
            platformType: {
                type: "int32",
                id: 2,
            },
            deviceType: {
                type: "int32",
                id: 3,
            },
            clientId: {
                type: "string",
                id: 4,
            },
            country: {
                type: "string",
                id: 5,
            },
            locale: {
                type: "string",
                id: 6,
            },
            trackingId: {
                type: "string",
                id: 7,
            },
            deviceUniqueIdentifier: {
                type: "string",
                id: 8,
            },
            trackingDeviceInfo: {
                type: "string",
                id: 9,
            },
            advertisingId: {
                type: "string",
                id: 10,
            },
            appsflyerId: {
                type: "string",
                id: 11,
            },
        },
    },
    RegisterResponse: {
        fields: {
            playerId: {
                type: "int64",
                id: 1,
            },
            authToken: {
                type: "string",
                id: 2,
            },
        },
    },
    ServerDispatchRequest: {
        fields: {
            playerId: {
                type: "int64",
                id: 1,
            },
            commandCode: {
                type: "int32",
                id: 2,
            },
            data: {
                type: "bytes",
                id: 3,
            },
        },
    },
    ServerDispatchResponse: {
        fields: {
            playerId: {
                type: "int64",
                id: 1,
            },
            commandCode: {
                type: "int32",
                id: 2,
            },
        },
    },
    ServerExecuteRequest: {
        fields: {
            playerId: {
                type: "int64",
                id: 1,
            },
            commandCode: {
                type: "int32",
                id: 2,
            },
            data: {
                type: "bytes",
                id: 3,
            },
        },
    },
    ServerExecuteResponse: {
        fields: {
            playerId: {
                type: "int64",
                id: 1,
            },
            commandCode: {
                type: "int32",
                id: 2,
            },
        },
    },
    ServerLoginRequest: {
        fields: {},
    },
    ServerLoginResponse: {
        fields: {},
    },
    BalloonInfoRequest: {
        fields: {
            playerId: {
                type: "int64",
                id: 1,
            },
            activateCooldown: {
                type: "bool",
                id: 2,
            },
        },
    },
    BalloonInfoResponse: {
        fields: {
            remainingTime: {
                type: "int32",
                id: 1,
            },
            balloonContentId: {
                type: "int32",
                id: 2,
            },
            balloonLevel: {
                type: "int32",
                id: 3,
            },
            balloonOfferBufferTime: {
                type: "int32",
                id: 4,
            },
        },
    },
    ConsumeBalloonRequest: {
        fields: {
            playerId: {
                type: "int64",
                id: 1,
            },
            balloonContentId: {
                type: "int32",
                id: 2,
            },
            balloonLevel: {
                type: "int32",
                id: 3,
            },
            increaseReward: {
                type: "bool",
                id: 4,
            },
        },
    },
    ConsumeBalloonResponse: {
        fields: {
            info: {
                type: "BalloonInfoResponse",
                id: 1,
            },
        },
    },
    PopBalloonRequest: {
        fields: {
            playerId: {
                type: "int64",
                id: 1,
            },
            adAvailable: {
                type: "bool",
                id: 2,
            },
        },
    },
    PopBalloonResponse: {
        fields: {
            info: {
                type: "BalloonInfoResponse",
                id: 1,
            },
        },
    },
    Message: {
        fields: {
            messageId: {
                type: "int64",
                id: 1,
            },
            messageType: {
                type: "MessageType",
                id: 2,
            },
            creationTimestamp: {
                type: "int32",
                id: 3,
            },
            playerId: {
                type: "int64",
                id: 4,
            },
            playerName: {
                type: "string",
                id: 5,
            },
            coopId: {
                type: "int64",
                id: 6,
            },
            coopName: {
                type: "string",
                id: 7,
            },
            profilePictureId: {
                type: "int32",
                id: 8,
            },
            originalMessage: {
                type: "string",
                id: 9,
            },
            xp: {
                type: "int64",
                id: 10,
            },
        },
    },
    MessageType: {
        values: {
            USER: 0,
            SYSTEM: 1,
            GAMEMASTER: 2,
        },
    },
    NewMessageInChatRoomNotification: {
        fields: {
            chatRoomId: {
                type: "string",
                id: 1,
            },
            message: {
                type: "Message",
                id: 2,
            },
            chatRoomType: {
                type: "ChatRoomType",
                id: 3,
            },
        },
    },
    ChatRoomType: {
        values: {
            COOP: 0,
            COOP_LEADER: 1,
            GLOBAL: 2,
            PLAYER_TO_PLAYER: 3,
        },
    },
    Room: {
        fields: {
            chatRoomId: {
                type: "string",
                id: 1,
            },
            chatRoomMessages: {
                rule: "repeated",
                type: "Message",
                id: 2,
            },
            chatRoomType: {
                type: "ChatRoomType",
                id: 3,
            },
            playerName: {
                type: "string",
                id: 4,
            },
            playerId: {
                type: "int64",
                id: 5,
            },
            profilePictureId: {
                type: "int32",
                id: 6,
            },
        },
    },
    GetChatRoomRequest: {
        fields: {
            chatRoomId: {
                type: "string",
                id: 1,
            },
            chatRoomType: {
                type: "ChatRoomType",
                id: 2,
            },
        },
    },
    GetChatRoomResponse: {
        fields: {
            chatRoom: {
                type: "Room",
                id: 1,
            },
        },
    },
    LoginChatServerRequest: {
        fields: {
            playerId: {
                type: "int64",
                id: 1,
            },
            authenticationToken: {
                type: "string",
                id: 2,
            },
        },
    },
    LoginChatServerResponse: {
        fields: {
            authenticationToken: {
                type: "string",
                id: 1,
            },
            playerToPlayerChatRooms: {
                rule: "repeated",
                type: "Room",
                id: 2,
            },
            bootUpTime: {
                type: "int32",
                id: 3,
            },
        },
    },
    PostInChatRoomRequest: {
        fields: {
            chatRoomId: {
                type: "string",
                id: 1,
            },
            chatMessage: {
                type: "string",
                id: 2,
            },
            chatRoomType: {
                type: "ChatRoomType",
                id: 3,
            },
        },
    },
    PostInChatRoomResponse: {
        fields: {
            message: {
                type: "Message",
                id: 1,
            },
        },
    },
    AddAdventurerXpCheatRequest: {
        fields: {
            playerId: {
                type: "int64",
                id: 1,
            },
            xp: {
                type: "int64",
                id: 2,
            },
            level: {
                type: "int32",
                id: 3,
            },
        },
    },
    AddAdventurerXpCheatResponse: {
        fields: {
            xp: {
                type: "int64",
                id: 1,
            },
            level: {
                type: "int32",
                id: 2,
            },
        },
    },
    AddBuildingCheatRequest: {
        fields: {
            playerId: {
                type: "int64",
                id: 1,
            },
            typeId: {
                type: "int32",
                id: 2,
            },
            stage: {
                type: "int32",
                id: 3,
            },
            amount: {
                type: "int64",
                id: 4,
            },
            pendingTypeId: {
                type: "int32",
                id: 5,
            },
            pendingSourceId: {
                type: "int32",
                id: 6,
            },
        },
    },
    AddBuildingCheatResponse: {
        fields: {
            typeId: {
                type: "int32",
                id: 1,
            },
            amount: {
                type: "int64",
                id: 2,
            },
            stage: {
                type: "int32",
                id: 3,
            },
            pendingTypeId: {
                type: "int32",
                id: 4,
            },
            pendingSourceId: {
                type: "int32",
                id: 5,
            },
            pendingTransferId: {
                type: "int64",
                id: 6,
            },
        },
    },
    AddBuildingSlotCheatRequest: {
        fields: {
            farmId: {
                type: "int32",
                id: 1,
            },
        },
    },
    AddBuildingSlotCheatResponse: {
        fields: {
            buildingSlots: {
                rule: "repeated",
                type: "BuildingSlot",
                id: 1,
            },
        },
    },
    BuildingSlot: {
        fields: {
            buildingId: {
                type: "int32",
                id: 1,
            },
        },
    },
    AddCoopProjectCompletionsCheatRequest: {
        fields: {
            coopId: {
                type: "int64",
                id: 1,
            },
            typeId: {
                type: "int32",
                id: 2,
            },
            difficulty: {
                type: "int32",
                id: 3,
            },
            amount: {
                type: "int32",
                id: 4,
            },
        },
    },
    AddCoopProjectCompletionsCheatResponse: {
        fields: {},
    },
    AddCoopResourceCheatRequest: {
        fields: {
            coopId: {
                type: "int64",
                id: 1,
            },
            itemId: {
                type: "int32",
                id: 2,
            },
            amount: {
                type: "int64",
                id: 3,
            },
        },
    },
    AddCoopResourceCheatResponse: {
        fields: {
            itemId: {
                type: "int32",
                id: 1,
            },
            amount: {
                type: "int64",
                id: 2,
            },
        },
    },
    AddCoopXpCheatRequest: {
        fields: {
            coopId: {
                type: "int64",
                id: 1,
            },
            xp: {
                type: "int64",
                id: 2,
            },
            level: {
                type: "int32",
                id: 3,
            },
        },
    },
    AddCoopXpCheatResponse: {
        fields: {
            xp: {
                type: "int64",
                id: 1,
            },
            level: {
                type: "int32",
                id: 2,
            },
        },
    },
    AddOutskirtXpCheatRequest: {
        fields: {
            playerId: {
                type: "int64",
                id: 1,
            },
            xp: {
                type: "int64",
                id: 2,
            },
            outskirtType: {
                type: "int32",
                id: 3,
            },
        },
    },
    AddOutskirtXpCheatResponse: {
        fields: {
            xp: {
                type: "int64",
                id: 1,
            },
            stage: {
                type: "int32",
                id: 2,
            },
        },
    },
    AddPvpEnergyCheatRequest: {
        fields: {
            energyAmountToAdd: {
                type: "int32",
                id: 1,
            },
            eventId: {
                type: "int32",
                id: 2,
            },
        },
    },
    AddPvpEnergyCheatResponse: {
        fields: {},
    },
    AddPvpUnitsCheatRequest: {
        fields: {
            unitAmount: {
                type: "int32",
                id: 1,
            },
        },
    },
    AddPvpUnitsCheatResponse: {
        fields: {},
    },
    AddResourceCheatRequest: {
        fields: {
            playerId: {
                type: "int64",
                id: 1,
            },
            itemId: {
                type: "int32",
                id: 2,
            },
            amount: {
                type: "int64",
                id: 3,
            },
            pendingTypeId: {
                type: "int32",
                id: 4,
            },
            pendingSourceId: {
                type: "int32",
                id: 5,
            },
        },
    },
    AddResourceCheatResponse: {
        fields: {
            itemId: {
                type: "int32",
                id: 1,
            },
            amount: {
                type: "int64",
                id: 2,
            },
            pendingTypeId: {
                type: "int32",
                id: 3,
            },
            pendingSourceId: {
                type: "int32",
                id: 4,
            },
            pendingTransferId: {
                type: "int64",
                id: 5,
            },
        },
    },
    AddXpCheatRequest: {
        fields: {
            playerId: {
                type: "int64",
                id: 1,
            },
            xp: {
                type: "int64",
                id: 2,
            },
            level: {
                type: "int32",
                id: 3,
            },
        },
    },
    AddXpCheatResponse: {
        fields: {
            xp: {
                type: "int64",
                id: 1,
            },
            level: {
                type: "int32",
                id: 2,
            },
        },
    },
    AdjustCookingTimeCheatRequest: {
        fields: {
            panId: {
                type: "int32",
                id: 1,
            },
            secondsLeft: {
                type: "int32",
                id: 2,
            },
        },
    },
    AdjustCookingTimeCheatResponse: {
        fields: {
            pan: {
                type: "PanInfo",
                id: 1,
            },
        },
    },
    AdjustCoopProjectTimeCheatRequest: {
        fields: {
            coopId: {
                type: "int64",
                id: 1,
            },
            projectId: {
                type: "int32",
                id: 2,
            },
            secondsLeft: {
                type: "int32",
                id: 3,
            },
        },
    },
    AdjustCoopProjectTimeCheatResponse: {
        fields: {},
    },
    AdjustUnlockPackageTimeCheatRequest: {
        fields: {
            reducedSeconds: {
                type: "int32",
                id: 1,
            },
        },
    },
    AdjustUnlockPackageTimeCheatResponse: {
        fields: {},
    },
    AssignCoopMemberRoleCheatRequest: {
        fields: {
            coopId: {
                type: "int64",
                id: 1,
            },
            playerIdToAssign: {
                type: "int64",
                id: 2,
            },
            roleId: {
                type: "int32",
                id: 3,
            },
        },
    },
    AssignCoopMemberRoleCheatResponse: {
        fields: {
            playerIdToAssign: {
                type: "int64",
                id: 1,
            },
            coop: {
                type: "CoopParam",
                id: 2,
            },
            member: {
                rule: "repeated",
                type: "CoopMemberParam",
                id: 3,
            },
        },
    },
    ClientIpCheatRequest: {
        fields: {
            playerId: {
                type: "int64",
                id: 1,
            },
            clientIp: {
                type: "string",
                id: 2,
            },
        },
    },
    ClientIpCheatResponse: {
        fields: {
            clientIp: {
                type: "string",
                id: 1,
            },
        },
    },
    CollectProductsCheatRequest: {
        fields: {
            playerId: {
                type: "int64",
                id: 1,
            },
            itemId: {
                type: "int32",
                id: 2,
            },
            amount: {
                type: "int64",
                id: 3,
            },
        },
    },
    CollectProductsCheatResponse: {
        fields: {
            itemId: {
                type: "int32",
                id: 1,
            },
            amount: {
                type: "int64",
                id: 2,
            },
        },
    },
    LastLoginCheatRequest: {
        fields: {
            playerId: {
                type: "int64",
                id: 1,
            },
            lastLoginTime: {
                type: "int32",
                id: 2,
            },
        },
    },
    LastLoginCheatResponse: {
        fields: {
            lastLoginTime: {
                type: "int32",
                id: 1,
            },
        },
    },
    NextOffersCheatRequest: {
        fields: {
            playerId: {
                type: "int64",
                id: 1,
            },
        },
    },
    NextOffersCheatResponse: {
        fields: {},
    },
    ResetBalloonOfferCheatRequest: {
        fields: {
            playerId: {
                type: "int64",
                id: 1,
            },
        },
    },
    ResetBalloonOfferCheatResponse: {
        fields: {},
    },
    ResetLimitedActionsCheatRequest: {
        fields: {
            playerId: {
                type: "int64",
                id: 1,
            },
            amount: {
                type: "int32",
                id: 2,
            },
            timeUntilReset: {
                type: "int32",
                id: 3,
            },
        },
    },
    ResetLimitedActionsCheatResponse: {
        fields: {},
    },
    ResetOfferCharacteristicsCheatRequest: {
        fields: {
            playerId: {
                type: "int64",
                id: 1,
            },
        },
    },
    ResetOfferCharacteristicsCheatResponse: {
        fields: {},
    },
    SubscriptionCheatRequest: {
        fields: {
            playerId: {
                type: "int64",
                id: 1,
            },
            remainingSeconds: {
                type: "int32",
                id: 2,
            },
            packageId: {
                type: "string",
                id: 3,
            },
        },
    },
    SubscriptionCheatResponse: {
        fields: {},
    },
    SubscriptionLevelCheatRequest: {
        fields: {
            playerId: {
                type: "int64",
                id: 1,
            },
            packageId: {
                type: "int32",
                id: 2,
            },
            level: {
                type: "int32",
                id: 3,
            },
        },
    },
    SubscriptionLevelCheatResponse: {
        fields: {},
    },
    UpdateCollectLeagueCheatRequest: {
        fields: {
            playerId: {
                type: "int64",
                id: 1,
            },
            leagueId: {
                type: "int32",
                id: 2,
            },
        },
    },
    UpdateCollectLeagueCheatResponse: {
        fields: {
            leagueId: {
                type: "int32",
                id: 1,
            },
        },
    },
    UpdateCoopLeagueCheatRequest: {
        fields: {
            coopId: {
                type: "int64",
                id: 1,
            },
            leagueId: {
                type: "int32",
                id: 2,
            },
        },
    },
    UpdateCoopLeagueCheatResponse: {
        fields: {
            leagueId: {
                type: "int32",
                id: 1,
            },
        },
    },
    UpdateCoopMemberJoinTimeCheatRequest: {
        fields: {
            playerId: {
                type: "int64",
                id: 1,
            },
            coopId: {
                type: "int64",
                id: 2,
            },
            secondsToBeDeducted: {
                type: "int32",
                id: 3,
            },
        },
    },
    UpdateCoopMemberJoinTimeCheatResponse: {
        fields: {
            joinTimeStamp: {
                type: "int32",
                id: 1,
            },
        },
    },
    UpdateEventEasyCheatRequest: {
        fields: {
            eventId: {
                type: "int32",
                id: 1,
            },
            startInSeconds: {
                type: "int32",
                id: 2,
            },
            endInSeconds: {
                type: "int32",
                id: 3,
            },
        },
    },
    UpdateEventEasyCheatResponse: {
        fields: {
            event: {
                type: "EventParam",
                id: 1,
            },
        },
    },
    UpdateEventScheduleCheatRequest: {
        fields: {
            farmEventId: {
                type: "int32",
                id: 1,
            },
            startInSeconds: {
                type: "int32",
                id: 2,
            },
            eventDuration: {
                type: "int32",
                id: 3,
            },
            iterations: {
                type: "int32",
                id: 4,
            },
        },
    },
    UpdateEventScheduleCheatResponse: {
        fields: {},
    },
    UpdateLoginEventCheatRequest: {
        fields: {
            daystreak: {
                type: "int32",
                id: 1,
            },
            collectionWindowStartTime: {
                type: "int32",
                id: 2,
            },
        },
    },
    UpdateLoginEventCheatResponse: {
        fields: {},
    },
    UpdateLongTermPointEventCheatRequest: {
        fields: {
            playerId: {
                type: "int64",
                id: 1,
            },
            points: {
                type: "int32",
                id: 2,
            },
        },
    },
    UpdateLongTermPointEventCheatResponse: {
        fields: {
            points: {
                type: "int32",
                id: 1,
            },
        },
    },
    UpdatePlayerLeagueCheatRequest: {
        fields: {
            playerId: {
                type: "int64",
                id: 1,
            },
            leagueId: {
                type: "int32",
                id: 2,
            },
        },
    },
    UpdatePlayerLeagueCheatResponse: {
        fields: {
            leagueId: {
                type: "int32",
                id: 1,
            },
        },
    },
    UpdatePurchasePointCheatRequest: {
        fields: {
            playerId: {
                type: "int64",
                id: 1,
            },
            points: {
                type: "int32",
                id: 2,
            },
        },
    },
    UpdatePurchasePointCheatResponse: {
        fields: {
            points: {
                type: "int32",
                id: 1,
            },
        },
    },
    UpdatePvpEventPointsCheatRequest: {
        fields: {
            playerId: {
                type: "int64",
                id: 1,
            },
            points: {
                type: "int32",
                id: 2,
            },
        },
    },
    UpdatePvpEventPointsCheatResponse: {
        fields: {},
    },
    UpdateQuestTasksCheatRequest: {
        fields: {
            playerId: {
                type: "int64",
                id: 1,
            },
            questId: {
                type: "int32",
                id: 2,
            },
            remainingSecconds: {
                type: "int32",
                id: 3,
            },
            finish: {
                type: "bool",
                id: 4,
            },
        },
    },
    UpdateQuestTasksCheatResponse: {
        fields: {
            quest: {
                rule: "repeated",
                type: "QuestParam",
                id: 1,
            },
        },
    },
    UpdateShiftLevelCheatRequest: {
        fields: {
            playerId: {
                type: "int64",
                id: 1,
            },
            shiftLevel: {
                type: "int32",
                id: 2,
            },
            remainingSeconds: {
                type: "int32",
                id: 3,
            },
        },
    },
    UpdateShiftLevelCheatResponse: {
        fields: {
            shiftLevel: {
                type: "int32",
                id: 1,
            },
            remainingSeconds: {
                type: "int32",
                id: 2,
            },
        },
    },
    WebPaymentCheatRequest: {
        fields: {
            purchaseOfferCharacteristicId: {
                type: "int32",
                id: 1,
            },
            purchaseOfferName: {
                type: "string",
                id: 2,
            },
        },
    },
    WebPaymentCheatResponse: {
        fields: {},
    },
    AssignCoopMemberRoleRequest: {
        fields: {
            playerId: {
                type: "int64",
                id: 1,
            },
            coopId: {
                type: "int64",
                id: 2,
            },
            playerIdToAssign: {
                type: "int64",
                id: 3,
            },
            roleId: {
                type: "int32",
                id: 4,
            },
        },
    },
    AssignCoopMemberRoleResponse: {
        fields: {
            playerIdToAssign: {
                type: "int64",
                id: 1,
            },
            coop: {
                type: "CoopParam",
                id: 2,
            },
            member: {
                rule: "repeated",
                type: "CoopMemberParam",
                id: 3,
            },
        },
    },
    BuyCoopBuffRequest: {
        fields: {
            playerId: {
                type: "int64",
                id: 1,
            },
            coopId: {
                type: "int64",
                id: 2,
            },
            improvementId: {
                type: "int32",
                id: 3,
            },
        },
    },
    BuyCoopBuffResponse: {
        fields: {
            coopId: {
                type: "int64",
                id: 1,
            },
            improvementId: {
                type: "int32",
                id: 2,
            },
            buff: {
                rule: "repeated",
                type: "BuffParam",
                id: 3,
            },
            cost: {
                rule: "repeated",
                type: "ItemParam",
                id: 4,
            },
        },
    },
    BuyCoopImprovementRequest: {
        fields: {
            playerId: {
                type: "int64",
                id: 1,
            },
            coopId: {
                type: "int64",
                id: 2,
            },
            improvementId: {
                type: "int32",
                id: 3,
            },
        },
    },
    BuyCoopImprovementResponse: {
        fields: {
            coopId: {
                type: "int64",
                id: 1,
            },
            improvement: {
                type: "ImprovementParam",
                id: 2,
            },
            buff: {
                rule: "repeated",
                type: "BuffParam",
                id: 3,
            },
            cost: {
                rule: "repeated",
                type: "ItemParam",
                id: 4,
            },
        },
    },
    CollectCoopPointsRequest: {
        fields: {
            playerId: {
                type: "int64",
                id: 1,
            },
            coopId: {
                type: "int64",
                id: 2,
            },
        },
    },
    CollectCoopPointsResponse: {
        fields: {
            coopId: {
                type: "int64",
                id: 1,
            },
            itemId: {
                type: "int32",
                id: 2,
            },
            amount: {
                type: "int64",
                id: 3,
            },
        },
    },
    CoopBuffInfoRequest: {
        fields: {
            playerId: {
                type: "int64",
                id: 1,
            },
            coopId: {
                type: "int64",
                id: 2,
            },
        },
    },
    CoopBuffInfoResponse: {
        fields: {
            buff: {
                rule: "repeated",
                type: "BuffParam",
                id: 1,
            },
        },
    },
    CoopCancelInviteRequest: {
        fields: {
            playerId: {
                type: "int64",
                id: 1,
            },
            coopId: {
                type: "int64",
                id: 2,
            },
            playerIdToCancel: {
                type: "int64",
                id: 3,
            },
        },
    },
    CoopCancelInviteResponse: {
        fields: {
            invite: {
                rule: "repeated",
                type: "CoopInviteParam",
                id: 1,
            },
        },
    },
    CoopImprovementInfoRequest: {
        fields: {
            playerId: {
                type: "int64",
                id: 1,
            },
            coopId: {
                type: "int64",
                id: 2,
            },
        },
    },
    CoopImprovementInfoResponse: {
        fields: {
            coopId: {
                type: "int64",
                id: 1,
            },
            improvement: {
                rule: "repeated",
                type: "ImprovementParam",
                id: 2,
            },
        },
    },
    CoopInfoRequest: {
        fields: {
            playerId: {
                type: "int64",
                id: 1,
            },
            coopId: {
                type: "int64",
                id: 2,
            },
        },
    },
    CoopInfoResponse: {
        fields: {
            coop: {
                type: "CoopParam",
                id: 1,
            },
            project: {
                type: "CoopProjectParam",
                id: 2,
            },
        },
    },
    CoopInventoryInfoRequest: {
        fields: {
            playerId: {
                type: "int64",
                id: 1,
            },
            coopId: {
                type: "int64",
                id: 2,
            },
        },
    },
    CoopInventoryInfoResponse: {
        fields: {
            resource: {
                rule: "repeated",
                type: "ItemParam",
                id: 1,
            },
            building: {
                rule: "repeated",
                type: "ItemParam",
                id: 2,
            },
            package: {
                rule: "repeated",
                type: "ItemParam",
                id: 3,
            },
            profilePicture: {
                rule: "repeated",
                type: "ItemParam",
                id: 4,
            },
        },
    },
    CoopInviteInfoRequest: {
        fields: {
            playerId: {
                type: "int64",
                id: 1,
            },
            coopId: {
                type: "int64",
                id: 2,
            },
        },
    },
    CoopInviteInfoResponse: {
        fields: {
            invite: {
                rule: "repeated",
                type: "CoopInviteParam",
                id: 1,
            },
        },
    },
    CoopInvitePlayerRequest: {
        fields: {
            playerId: {
                type: "int64",
                id: 1,
            },
            coopId: {
                type: "int64",
                id: 2,
            },
            playerIdToInvite: {
                type: "int64",
                id: 3,
            },
        },
    },
    CoopInvitePlayerResponse: {
        fields: {
            invite: {
                rule: "repeated",
                type: "CoopInviteParam",
                id: 1,
            },
        },
    },
    CoopMemberInfoRequest: {
        fields: {
            playerId: {
                type: "int64",
                id: 1,
            },
            coopId: {
                type: "int64",
                id: 2,
            },
        },
    },
    CoopMemberInfoResponse: {
        fields: {
            coop: {
                type: "CoopParam",
                id: 1,
            },
            member: {
                rule: "repeated",
                type: "CoopMemberParam",
                id: 2,
            },
        },
    },
    CoopMessageInfoRequest: {
        fields: {
            playerId: {
                type: "int64",
                id: 1,
            },
            coopId: {
                type: "int64",
                id: 2,
            },
        },
    },
    CoopMessageInfoResponse: {
        fields: {
            messageParams: {
                rule: "repeated",
                type: "CoopMessageParam",
                id: 1,
            },
        },
    },
    CoopPointsInfoRequest: {
        fields: {
            playerId: {
                type: "int64",
                id: 1,
            },
            coopId: {
                type: "int64",
                id: 2,
            },
        },
    },
    CoopPointsInfoResponse: {
        fields: {
            coopId: {
                type: "int64",
                id: 1,
            },
            cooldownTime: {
                type: "int32",
                id: 2,
            },
            projectPoints: {
                type: "int64",
                id: 3,
            },
            points: {
                rule: "repeated",
                type: "CoopMemberPointsParam",
                id: 4,
            },
        },
    },
    CoopProjectInfoRequest: {
        fields: {
            playerId: {
                type: "int64",
                id: 1,
            },
            coopId: {
                type: "int64",
                id: 2,
            },
            projectId: {
                type: "int32",
                id: 3,
            },
        },
    },
    CoopProjectInfoResponse: {
        fields: {
            coopId: {
                type: "int64",
                id: 1,
            },
            project: {
                type: "CoopProjectParam",
                id: 2,
            },
            points: {
                rule: "repeated",
                type: "CoopMemberPointsParam",
                id: 3,
            },
        },
    },
    CoopProjectTypeInfoRequest: {
        fields: {
            playerId: {
                type: "int64",
                id: 1,
            },
            coopId: {
                type: "int64",
                id: 2,
            },
        },
    },
    CoopProjectTypeInfoResponse: {
        fields: {
            coopId: {
                type: "int64",
                id: 1,
            },
            type: {
                rule: "repeated",
                type: "CoopProjectTypeParam",
                id: 2,
            },
        },
    },
    CreateCoopRequest: {
        fields: {
            playerId: {
                type: "int64",
                id: 1,
            },
            language: {
                type: "string",
                id: 2,
            },
            minLevel: {
                type: "int32",
                id: 3,
            },
            joinPolicy: {
                type: "int32",
                id: 4,
            },
            description: {
                type: "string",
                id: 5,
            },
            name: {
                type: "string",
                id: 6,
            },
        },
    },
    CreateCoopResponse: {
        fields: {
            coop: {
                type: "CoopParam",
                id: 1,
            },
            member: {
                rule: "repeated",
                type: "CoopMemberParam",
                id: 2,
            },
            cost: {
                rule: "repeated",
                type: "ItemParam",
                id: 3,
            },
        },
    },
    DonateToCoopRequest: {
        fields: {
            playerId: {
                type: "int64",
                id: 1,
            },
            coopId: {
                type: "int64",
                id: 2,
            },
            softCurrencyStack: {
                type: "int32",
                id: 3,
            },
            hardCurrencyStack: {
                type: "int32",
                id: 4,
            },
        },
    },
    DonateToCoopResponse: {
        fields: {
            fundsGranted: {
                type: "int64",
                id: 1,
            },
            cost: {
                rule: "repeated",
                type: "ItemParam",
                id: 2,
            },
        },
    },
    JoinableCoopListRequest: {
        fields: {
            playerId: {
                type: "int64",
                id: 1,
            },
            language: {
                type: "string",
                id: 2,
            },
            joinPolicy: {
                type: "int32",
                id: 3,
            },
        },
    },
    JoinableCoopListResponse: {
        fields: {
            coops: {
                rule: "repeated",
                type: "CoopParam",
                id: 1,
            },
        },
    },
    JoinCoopRequest: {
        fields: {
            playerId: {
                type: "int64",
                id: 1,
            },
            coopId: {
                type: "int64",
                id: 2,
            },
        },
    },
    JoinCoopResponse: {
        fields: {
            coop: {
                type: "CoopParam",
                id: 1,
            },
            member: {
                rule: "repeated",
                type: "CoopMemberParam",
                id: 2,
            },
        },
    },
    KickCoopMemberRequest: {
        fields: {
            playerId: {
                type: "int64",
                id: 1,
            },
            coopId: {
                type: "int64",
                id: 2,
            },
            playerIdToKick: {
                type: "int64",
                id: 3,
            },
        },
    },
    KickCoopMemberResponse: {
        fields: {
            playerIdToKick: {
                type: "int64",
                id: 1,
            },
            coop: {
                type: "CoopParam",
                id: 2,
            },
            member: {
                rule: "repeated",
                type: "CoopMemberParam",
                id: 3,
            },
        },
    },
    KickedCoopMemberInfoRequest: {
        fields: {
            playerId: {
                type: "int64",
                id: 1,
            },
            coopId: {
                type: "int64",
                id: 2,
            },
        },
    },
    KickedCoopMemberInfoResponse: {
        fields: {
            coopId: {
                type: "int64",
                id: 1,
            },
        },
    },
    LeaveCoopRequest: {
        fields: {
            playerId: {
                type: "int64",
                id: 1,
            },
            coopId: {
                type: "int64",
                id: 2,
            },
        },
    },
    LeaveCoopResponse: {
        fields: {
            coopId: {
                type: "int64",
                id: 1,
            },
        },
    },
    SearchCoopRequest: {
        fields: {
            playerId: {
                type: "int64",
                id: 1,
            },
            name: {
                type: "string",
                id: 2,
            },
        },
    },
    SearchCoopResponse: {
        fields: {
            coop: {
                type: "CoopParam",
                id: 1,
            },
            member: {
                rule: "repeated",
                type: "CoopMemberParam",
                id: 2,
            },
        },
    },
    SendCoopPointsRequest: {
        fields: {
            playerId: {
                type: "int64",
                id: 1,
            },
            coopId: {
                type: "int64",
                id: 2,
            },
        },
    },
    SendCoopPointsResponse: {
        fields: {
            coopId: {
                type: "int64",
                id: 1,
            },
            cooldownTime: {
                type: "int32",
                id: 2,
            },
            itemId: {
                type: "int32",
                id: 3,
            },
            amount: {
                type: "int64",
                id: 4,
            },
        },
    },
    StartCoopProjectRequest: {
        fields: {
            playerId: {
                type: "int64",
                id: 1,
            },
            coopId: {
                type: "int64",
                id: 2,
            },
            typeId: {
                type: "int32",
                id: 3,
            },
            difficulty: {
                type: "int32",
                id: 4,
            },
        },
    },
    StartCoopProjectResponse: {
        fields: {
            coopId: {
                type: "int64",
                id: 1,
            },
            project: {
                type: "CoopProjectParam",
                id: 2,
            },
        },
    },
    StopCoopProjectRequest: {
        fields: {
            playerId: {
                type: "int64",
                id: 1,
            },
            coopId: {
                type: "int64",
                id: 2,
            },
            projectId: {
                type: "int32",
                id: 3,
            },
        },
    },
    StopCoopProjectResponse: {
        fields: {
            coopId: {
                type: "int64",
                id: 1,
            },
            projectId: {
                type: "int32",
                id: 2,
            },
        },
    },
    UpdateCoopRequest: {
        fields: {
            playerId: {
                type: "int64",
                id: 1,
            },
            coopId: {
                type: "int64",
                id: 2,
            },
            language: {
                type: "string",
                id: 3,
            },
            minLevel: {
                type: "int32",
                id: 4,
            },
            joinPolicy: {
                type: "int32",
                id: 5,
            },
            description: {
                type: "string",
                id: 6,
            },
            internalNotice: {
                type: "string",
                id: 7,
            },
        },
    },
    UpdateCoopResponse: {
        fields: {
            coop: {
                type: "CoopParam",
                id: 1,
            },
            project: {
                type: "CoopProjectParam",
                id: 2,
            },
        },
    },
    UpdateCoopLeagueEventRequest: {
        fields: {
            coopId: {
                type: "int64",
                id: 1,
            },
            points: {
                type: "int64",
                id: 2,
            },
        },
    },
    UpdateCoopLeagueEventResponse: {
        fields: {
            coopId: {
                type: "int64",
                id: 1,
            },
            eventId: {
                type: "int32",
                id: 2,
            },
            leagueId: {
                type: "int32",
                id: 3,
            },
            points: {
                type: "int64",
                id: 4,
            },
        },
    },
    UpdateCoopProjectRequest: {
        fields: {
            playerId: {
                type: "int64",
                id: 1,
            },
            item: {
                rule: "repeated",
                type: "ItemParam",
                id: 2,
            },
        },
    },
    UpdateCoopProjectResponse: {
        fields: {},
    },
    BuyFarmImprovementRequest: {
        fields: {
            playerId: {
                type: "int64",
                id: 1,
            },
            farmId: {
                type: "int32",
                id: 2,
            },
            improvementId: {
                type: "int32",
                id: 3,
            },
        },
    },
    BuyFarmImprovementResponse: {
        fields: {
            improvement: {
                type: "ImprovementParam",
                id: 1,
            },
            buff: {
                rule: "repeated",
                type: "BuffParam",
                id: 2,
            },
            cost: {
                rule: "repeated",
                type: "ItemParam",
                id: 3,
            },
        },
    },
    DemolishRequest: {
        fields: {
            playerId: {
                type: "int64",
                id: 1,
            },
            farmId: {
                type: "int32",
                id: 2,
            },
            buildingId: {
                type: "int32",
                id: 3,
            },
        },
    },
    DemolishResponse: {
        fields: {
            farmId: {
                type: "int32",
                id: 1,
            },
            buildingId: {
                type: "int32",
                id: 2,
            },
            refund: {
                rule: "repeated",
                type: "ItemParam",
                id: 3,
            },
            buff: {
                rule: "repeated",
                type: "BuffParam",
                id: 4,
            },
        },
    },
    ExpandFarmGoldRequest: {
        fields: {
            playerId: {
                type: "int64",
                id: 1,
            },
            farmId: {
                type: "int32",
                id: 2,
            },
            expansionId: {
                type: "int32",
                id: 3,
            },
        },
    },
    ExpandFarmGoldResponse: {
        fields: {
            farmId: {
                type: "int32",
                id: 1,
            },
            expansionId: {
                type: "int32",
                id: 2,
            },
            cost: {
                rule: "repeated",
                type: "ItemParam",
                id: 3,
            },
        },
    },
    ExpandFarmResourceRequest: {
        fields: {
            playerId: {
                type: "int64",
                id: 1,
            },
            farmId: {
                type: "int32",
                id: 2,
            },
            expansionId: {
                type: "int32",
                id: 3,
            },
        },
    },
    ExpandFarmResourceResponse: {
        fields: {
            farmId: {
                type: "int32",
                id: 1,
            },
            expansionId: {
                type: "int32",
                id: 2,
            },
            cost: {
                rule: "repeated",
                type: "ItemParam",
                id: 3,
            },
        },
    },
    FinishConstructRequest: {
        fields: {
            playerId: {
                type: "int64",
                id: 1,
            },
            farmId: {
                type: "int32",
                id: 2,
            },
            buildingId: {
                type: "int32",
                id: 3,
            },
        },
    },
    FinishConstructResponse: {
        fields: {
            farmId: {
                type: "int32",
                id: 1,
            },
            buildingId: {
                type: "int32",
                id: 2,
            },
            xp: {
                type: "int64",
                id: 3,
            },
            buff: {
                rule: "repeated",
                type: "BuffParam",
                id: 4,
            },
            adventurerXp: {
                type: "int64",
                id: 5,
            },
        },
    },
    FinishUpgradeRequest: {
        fields: {
            playerId: {
                type: "int64",
                id: 1,
            },
            farmId: {
                type: "int32",
                id: 2,
            },
            buildingId: {
                type: "int32",
                id: 3,
            },
        },
    },
    FinishUpgradeResponse: {
        fields: {
            farmId: {
                type: "int32",
                id: 1,
            },
            buildingId: {
                type: "int32",
                id: 2,
            },
            xp: {
                type: "int64",
                id: 3,
            },
            buff: {
                rule: "repeated",
                type: "BuffParam",
                id: 4,
            },
            adventurerXp: {
                type: "int64",
                id: 5,
            },
        },
    },
    MoveBuildingRequest: {
        fields: {
            playerId: {
                type: "int64",
                id: 1,
            },
            farmId: {
                type: "int32",
                id: 2,
            },
            buildingId: {
                type: "int32",
                id: 3,
            },
            posX: {
                type: "int32",
                id: 4,
            },
            posY: {
                type: "int32",
                id: 5,
            },
            flipped: {
                type: "bool",
                id: 6,
            },
        },
    },
    MoveBuildingResponse: {
        fields: {
            farmId: {
                type: "int32",
                id: 1,
            },
            buildingId: {
                type: "int32",
                id: 2,
            },
        },
    },
    SkipConstructRequest: {
        fields: {
            playerId: {
                type: "int64",
                id: 1,
            },
            farmId: {
                type: "int32",
                id: 2,
            },
            buildingId: {
                type: "int32",
                id: 3,
            },
            itemId: {
                type: "int32",
                id: 4,
            },
            amount: {
                type: "int64",
                id: 5,
            },
        },
    },
    SkipConstructResponse: {
        fields: {
            farmId: {
                type: "int32",
                id: 1,
            },
            buildingId: {
                type: "int32",
                id: 2,
            },
            itemId: {
                type: "int32",
                id: 3,
            },
            amount: {
                type: "int64",
                id: 4,
            },
        },
    },
    SkipUpgradeRequest: {
        fields: {
            playerId: {
                type: "int64",
                id: 1,
            },
            farmId: {
                type: "int32",
                id: 2,
            },
            buildingId: {
                type: "int32",
                id: 3,
            },
            itemId: {
                type: "int32",
                id: 4,
            },
            amount: {
                type: "int64",
                id: 5,
            },
        },
    },
    SkipUpgradeResponse: {
        fields: {
            farmId: {
                type: "int32",
                id: 1,
            },
            buildingId: {
                type: "int32",
                id: 2,
            },
            itemId: {
                type: "int32",
                id: 3,
            },
            amount: {
                type: "int64",
                id: 4,
            },
        },
    },
    StartConstructGoldRequest: {
        fields: {
            playerId: {
                type: "int64",
                id: 1,
            },
            farmId: {
                type: "int32",
                id: 2,
            },
            typeId: {
                type: "int32",
                id: 3,
            },
            posX: {
                type: "int32",
                id: 4,
            },
            posY: {
                type: "int32",
                id: 5,
            },
            flipped: {
                type: "bool",
                id: 6,
            },
        },
    },
    StartConstructGoldResponse: {
        fields: {
            farmId: {
                type: "int32",
                id: 1,
            },
            buildingId: {
                type: "int32",
                id: 2,
            },
            building: {
                type: "BuildingParam",
                id: 3,
            },
            cost: {
                rule: "repeated",
                type: "ItemParam",
                id: 4,
            },
        },
    },
    StartConstructResourceRequest: {
        fields: {
            playerId: {
                type: "int64",
                id: 1,
            },
            farmId: {
                type: "int32",
                id: 2,
            },
            typeId: {
                type: "int32",
                id: 3,
            },
            posX: {
                type: "int32",
                id: 4,
            },
            posY: {
                type: "int32",
                id: 5,
            },
            flipped: {
                type: "bool",
                id: 6,
            },
        },
    },
    StartConstructResourceResponse: {
        fields: {
            farmId: {
                type: "int32",
                id: 1,
            },
            buildingId: {
                type: "int32",
                id: 2,
            },
            building: {
                type: "BuildingParam",
                id: 3,
            },
            cost: {
                rule: "repeated",
                type: "ItemParam",
                id: 4,
            },
        },
    },
    StartUpgradeGoldRequest: {
        fields: {
            playerId: {
                type: "int64",
                id: 1,
            },
            farmId: {
                type: "int32",
                id: 2,
            },
            buildingId: {
                type: "int32",
                id: 3,
            },
        },
    },
    StartUpgradeGoldResponse: {
        fields: {
            farmId: {
                type: "int32",
                id: 1,
            },
            buildingId: {
                type: "int32",
                id: 2,
            },
            remainingTime: {
                type: "int32",
                id: 3,
            },
            cost: {
                rule: "repeated",
                type: "ItemParam",
                id: 4,
            },
        },
    },
    StartUpgradeResourceRequest: {
        fields: {
            playerId: {
                type: "int64",
                id: 1,
            },
            farmId: {
                type: "int32",
                id: 2,
            },
            buildingId: {
                type: "int32",
                id: 3,
            },
        },
    },
    StartUpgradeResourceResponse: {
        fields: {
            farmId: {
                type: "int32",
                id: 1,
            },
            buildingId: {
                type: "int32",
                id: 2,
            },
            remainingTime: {
                type: "int32",
                id: 3,
            },
            cost: {
                rule: "repeated",
                type: "ItemParam",
                id: 4,
            },
        },
    },
    StoreBuildingRequest: {
        fields: {
            playerId: {
                type: "int64",
                id: 1,
            },
            farmId: {
                type: "int32",
                id: 2,
            },
            buildingId: {
                type: "int32",
                id: 3,
            },
        },
    },
    StoreBuildingResponse: {
        fields: {
            farmId: {
                type: "int32",
                id: 1,
            },
            buildingId: {
                type: "int32",
                id: 2,
            },
        },
    },
    TemporaryFarmStartRequest: {
        fields: {
            playerId: {
                type: "int64",
                id: 1,
            },
            eventId: {
                type: "int32",
                id: 2,
            },
        },
    },
    TemporaryFarmStartResponse: {
        fields: {
            playerId: {
                type: "int64",
                id: 1,
            },
            farmId: {
                type: "int32",
                id: 2,
            },
            name: {
                type: "string",
                id: 3,
            },
            usedWorkers: {
                type: "int32",
                id: 4,
            },
            maxWorkers: {
                type: "int32",
                id: 5,
            },
            happiness: {
                type: "int32",
                id: 6,
            },
            buildings: {
                rule: "repeated",
                type: "BuildingParam",
                id: 7,
            },
            expansionIds: {
                rule: "repeated",
                type: "int32",
                id: 8,
            },
            buildingSlots: {
                rule: "repeated",
                type: "BuildingSlot",
                id: 9,
            },
        },
    },
    UnstoreBuildingRequest: {
        fields: {
            playerId: {
                type: "int64",
                id: 1,
            },
            farmId: {
                type: "int32",
                id: 2,
            },
            typeId: {
                type: "int32",
                id: 3,
            },
            posX: {
                type: "int32",
                id: 4,
            },
            posY: {
                type: "int32",
                id: 5,
            },
            flipped: {
                type: "bool",
                id: 6,
            },
            stageId: {
                type: "int32",
                id: 7,
            },
        },
    },
    UnstoreBuildingResponse: {
        fields: {
            farmId: {
                type: "int32",
                id: 1,
            },
            building: {
                type: "BuildingParam",
                id: 2,
            },
        },
    },
    FacebookPointsInfoRequest: {
        fields: {
            playerId: {
                type: "int64",
                id: 1,
            },
        },
    },
    FacebookPointsInfoResponse: {
        fields: {
            cooldownTime: {
                type: "int32",
                id: 1,
            },
            points: {
                rule: "repeated",
                type: "FriendPointsParam",
                id: 2,
            },
        },
    },
    SendAndCollectFacebookPointsRequest: {
        fields: {
            playerId: {
                type: "int64",
                id: 1,
            },
            friendId: {
                rule: "repeated",
                type: "string",
                id: 2,
            },
        },
    },
    SendAndCollectFacebookPointsResponse: {
        fields: {
            friendId: {
                rule: "repeated",
                type: "string",
                id: 1,
            },
            cooldownTime: {
                type: "int32",
                id: 2,
            },
            itemId: {
                type: "int32",
                id: 3,
            },
            amount: {
                type: "int64",
                id: 4,
            },
        },
    },
    CollectInboxItemAttachmentsRequest: {
        fields: {
            inboxItemId: {
                type: "int32",
                id: 1,
            },
        },
    },
    CollectInboxItemAttachmentsResponse: {
        fields: {},
    },
    DeleteInboxItemRequest: {
        fields: {
            inboxItemId: {
                type: "int32",
                id: 1,
            },
        },
    },
    DeleteInboxItemResponse: {
        fields: {},
    },
    InboxInfoRequest: {
        fields: {},
    },
    InboxInfoResponse: {
        fields: {
            inboxItems: {
                rule: "repeated",
                type: "InboxItemHeading",
                id: 1,
            },
        },
    },
    InboxItemHeading: {
        fields: {
            inboxItemId: {
                type: "int32",
                id: 1,
            },
            inboxItemType: {
                type: "InboxItemType",
                id: 2,
            },
            isRead: {
                type: "bool",
                id: 3,
            },
            inboxItemCreationTimestamp: {
                type: "int32",
                id: 4,
            },
            inboxItemAttachmentStatus: {
                type: "InboxItemAttachmentStatus",
                id: 5,
            },
        },
    },
    InboxItemType: {
        values: {
            SYSTEM: 0,
            GAME_MASTER: 1,
            VOUCHER: 2,
        },
    },
    InboxItemAttachmentStatus: {
        values: {
            CONTAINS_ATTACHMENTS: 0,
            COLLECTED_ATTACHMENTS: 1,
            NO_ATTACHMENTS: 2,
        },
    },
    VoucherBody: {
        fields: {},
    },
    InboxUpdateNotificationRequest: {
        fields: {
            inboxItemToBeSend: {
                type: "InboxItemHeading",
                id: 1,
            },
        },
    },
    InboxUpdateNotificationResponse: {
        fields: {
            inboxItem: {
                type: "InboxItemHeading",
                id: 1,
            },
        },
    },
    ReadInboxItemRequest: {
        fields: {
            inboxItemId: {
                type: "int32",
                id: 1,
            },
        },
    },
    ReadInboxItemResponse: {
        fields: {
            inboxItemBody: {
                type: "bytes",
                id: 1,
            },
            inboxItemAttachments: {
                rule: "repeated",
                type: "ItemParam",
                id: 2,
            },
        },
    },
    AchievementInfoRequest: {
        fields: {
            playerId: {
                type: "int64",
                id: 1,
            },
        },
    },
    AchievementInfoResponse: {
        fields: {
            achievement: {
                rule: "repeated",
                type: "AchievementParam",
                id: 1,
            },
        },
    },
    CafeRecipeInfoRequest: {
        fields: {
            playerId: {
                type: "int64",
                id: 1,
            },
        },
    },
    CafeRecipeInfoResponse: {
        fields: {
            recipe: {
                rule: "repeated",
                type: "CafeRecipeParam",
                id: 1,
            },
        },
    },
    CollectedPointRewardInfoRequest: {
        fields: {
            eventId: {
                type: "int32",
                id: 1,
            },
        },
    },
    CollectedPointRewardInfoResponse: {
        fields: {
            collectedReward: {
                rule: "repeated",
                type: "CollectedPointReward",
                id: 1,
            },
        },
    },
    CollectLeagueInfoRequest: {
        fields: {
            playerId: {
                type: "int64",
                id: 1,
            },
            eventId: {
                type: "int32",
                id: 2,
            },
        },
    },
    CollectLeagueInfoResponse: {
        fields: {
            playerId: {
                type: "int64",
                id: 1,
            },
            leagueId: {
                type: "int32",
                id: 2,
            },
            leagueXp: {
                type: "int64",
                id: 3,
            },
            eventProgress: {
                type: "LeagueEventProgressParam",
                id: 4,
            },
        },
    },
    CollectLeagueRankingRequest: {
        fields: {
            playerId: {
                type: "int64",
                id: 1,
            },
            eventId: {
                type: "int32",
                id: 2,
            },
        },
    },
    CollectLeagueRankingResponse: {
        fields: {
            eventId: {
                type: "int32",
                id: 1,
            },
            leagueId: {
                type: "int32",
                id: 2,
            },
            rankingEntry: {
                rule: "repeated",
                type: "LeagueRankingParam",
                id: 3,
            },
        },
    },
    ContractInfoRequest: {
        fields: {
            playerId: {
                type: "int64",
                id: 1,
            },
            farmId: {
                type: "int32",
                id: 2,
            },
        },
    },
    ContractInfoResponse: {
        fields: {
            farmId: {
                type: "int32",
                id: 1,
            },
            contract: {
                rule: "repeated",
                type: "ContractParam",
                id: 2,
            },
            market: {
                type: "OutskirtParam",
                id: 3,
            },
        },
    },
    CoopLeagueInfoRequest: {
        fields: {
            playerId: {
                type: "int64",
                id: 1,
            },
            coopId: {
                type: "int64",
                id: 2,
            },
            eventId: {
                type: "int32",
                id: 3,
            },
        },
    },
    CoopLeagueInfoResponse: {
        fields: {
            coopId: {
                type: "int64",
                id: 1,
            },
            leagueId: {
                type: "int32",
                id: 2,
            },
            leagueXp: {
                type: "int64",
                id: 3,
            },
            eventProgress: {
                type: "LeagueEventProgressParam",
                id: 4,
            },
        },
    },
    CoopLeagueRankingRequest: {
        fields: {
            playerId: {
                type: "int64",
                id: 1,
            },
            coopId: {
                type: "int64",
                id: 2,
            },
            eventId: {
                type: "int32",
                id: 3,
            },
        },
    },
    CoopLeagueRankingResponse: {
        fields: {
            eventId: {
                type: "int32",
                id: 1,
            },
            leagueId: {
                type: "int32",
                id: 2,
            },
            rankingEntry: {
                rule: "repeated",
                type: "LeagueRankingParam",
                id: 3,
            },
        },
    },
    EventInfoRequest: {
        fields: {
            playerId: {
                type: "int64",
                id: 1,
            },
        },
    },
    EventInfoResponse: {
        fields: {
            themedEvent: {
                rule: "repeated",
                type: "EventParam",
                id: 1,
            },
            leagueEvent: {
                rule: "repeated",
                type: "LeagueEventParam",
                id: 2,
            },
            coopLeagueEvent: {
                rule: "repeated",
                type: "LeagueEventParam",
                id: 3,
            },
            farmEvent: {
                rule: "repeated",
                type: "FarmEventParam",
                id: 4,
            },
            customerEvent: {
                rule: "repeated",
                type: "CustomerEventParam",
                id: 5,
            },
            collectEvent: {
                rule: "repeated",
                type: "LeagueEventParam",
                id: 6,
            },
            expansionDiscountEvent: {
                rule: "repeated",
                type: "EventParam",
                id: 7,
            },
            purchasePointsEvent: {
                rule: "repeated",
                type: "EventParam",
                id: 8,
            },
            traderEvent: {
                rule: "repeated",
                type: "EventParam",
                id: 9,
            },
            coopProjectBuff: {
                rule: "repeated",
                type: "EventParam",
                id: 10,
            },
            outskirtDiscountEvent: {
                rule: "repeated",
                type: "EventParam",
                id: 11,
            },
            questTreeEvent: {
                rule: "repeated",
                type: "EventParam",
                id: 12,
            },
            FertileAcreDiscountEvent: {
                rule: "repeated",
                type: "EventParam",
                id: 13,
            },
            FancyHouseDiscountEvent: {
                rule: "repeated",
                type: "EventParam",
                id: 14,
            },
            fortuneTellerEvent: {
                rule: "repeated",
                type: "EventParam",
                id: 15,
            },
            loginEvent: {
                rule: "repeated",
                type: "EventParam",
                id: 16,
            },
            longTermPointEvent: {
                rule: "repeated",
                type: "LongTermPointEventParam",
                id: 17,
            },
            primeTimeEvent: {
                rule: "repeated",
                type: "EventParam",
                id: 18,
            },
            fertileOrchardsDiscountEvent: {
                rule: "repeated",
                type: "EventParam",
                id: 19,
            },
            pvpMapLeagueEvent: {
                rule: "repeated",
                type: "LeagueEventParam",
                id: 20,
            },
            improvementDiscountEvent: {
                rule: "repeated",
                type: "EventParam",
                id: 21,
            },
            primeSaleEvent: {
                rule: "repeated",
                type: "EventParam",
                id: 22,
            },
        },
    },
    FarmInfoRequest: {
        fields: {
            playerId: {
                type: "int64",
                id: 1,
            },
            farmId: {
                type: "int32",
                id: 2,
            },
        },
    },
    FarmInfoResponse: {
        fields: {
            playerId: {
                type: "int64",
                id: 1,
            },
            farmId: {
                type: "int32",
                id: 2,
            },
            name: {
                type: "string",
                id: 3,
            },
            usedWorkers: {
                type: "int32",
                id: 4,
            },
            maxWorkers: {
                type: "int32",
                id: 5,
            },
            happiness: {
                type: "int32",
                id: 6,
            },
            buildings: {
                rule: "repeated",
                type: "BuildingParam",
                id: 7,
            },
            expansionIds: {
                rule: "repeated",
                type: "int32",
                id: 8,
            },
            farmImprovement: {
                rule: "repeated",
                type: "ImprovementParam",
                id: 9,
            },
            buildingSlots: {
                rule: "repeated",
                type: "BuildingSlot",
                id: 10,
            },
        },
    },
    FortuneTellerInfoRequest: {
        fields: {
            playerId: {
                type: "int64",
                id: 1,
            },
        },
    },
    FortuneTellerInfoResponse: {
        fields: {
            difficulty: {
                type: "int32",
                id: 1,
            },
            currentStep: {
                type: "int32",
                id: 2,
            },
            eventId: {
                type: "int32",
                id: 3,
            },
        },
    },
    InventoryInfoRequest: {
        fields: {
            playerId: {
                type: "int64",
                id: 1,
            },
        },
    },
    InventoryInfoResponse: {
        fields: {
            resource: {
                rule: "repeated",
                type: "ItemParam",
                id: 1,
            },
            building: {
                rule: "repeated",
                type: "ItemParam",
                id: 2,
            },
            package: {
                rule: "repeated",
                type: "ItemParam",
                id: 3,
            },
            profilePicture: {
                rule: "repeated",
                type: "ItemParam",
                id: 4,
            },
        },
    },
    LimitedActionInfoRequest: {
        fields: {
            playerId: {
                type: "int64",
                id: 1,
            },
        },
    },
    LimitedActionInfoResponse: {
        fields: {
            limitedAction: {
                rule: "repeated",
                type: "LimitedActionParam",
                id: 1,
            },
        },
    },
    LoginEventInfoRequest: {
        fields: {
            playerId: {
                type: "int64",
                id: 1,
            },
        },
    },
    LoginEventInfoResponse: {
        fields: {
            daystreak: {
                type: "int32",
                id: 1,
            },
            collectionDay: {
                type: "int32",
                id: 2,
            },
            secondsUntilNextCollect: {
                type: "int32",
                id: 3,
            },
            isCollectionOverlapping: {
                type: "bool",
                id: 4,
            },
        },
    },
    LongTermPointEventInfoRequest: {
        fields: {
            playerId: {
                type: "int64",
                id: 1,
            },
            eventId: {
                type: "int32",
                id: 2,
            },
        },
    },
    LongTermPointEventInfoResponse: {
        fields: {
            playerId: {
                type: "int64",
                id: 1,
            },
            eventId: {
                type: "int32",
                id: 2,
            },
            points: {
                type: "int64",
                id: 3,
            },
        },
    },
    LongTermPointEventRankInfoRequest: {
        fields: {
            playerId: {
                type: "int64",
                id: 1,
            },
            eventId: {
                type: "int32",
                id: 2,
            },
        },
    },
    LongTermPointEventRankInfoResponse: {
        fields: {
            playerId: {
                type: "int64",
                id: 1,
            },
            eventId: {
                type: "int32",
                id: 2,
            },
            points: {
                type: "int64",
                id: 3,
            },
            rank: {
                type: "int64",
                id: 4,
            },
        },
    },
    OfferCharacteristicsListRequest: {
        fields: {
            playerId: {
                type: "int64",
                id: 1,
            },
        },
    },
    OfferCharacteristicsListResponse: {
        fields: {
            offerBody: {
                rule: "repeated",
                type: "uint32",
                id: 1,
            },
            nextOffeBody: {
                rule: "repeated",
                type: "uint32",
                id: 2,
            },
            offerDuration: {
                type: "uint32",
                id: 3,
            },
            nextOfferDuration: {
                type: "uint32",
                id: 4,
            },
            offerHead: {
                rule: "repeated",
                type: "OfferParam",
                id: 5,
            },
            showIosSubscription: {
                type: "bool",
                id: 6,
            },
        },
    },
    OutskirtsInfoRequest: {
        fields: {
            playerId: {
                type: "int64",
                id: 1,
            },
            includeHappinessMachine: {
                type: "bool",
                id: 100,
            },
        },
    },
    OutskirtsInfoResponse: {
        fields: {
            playerId: {
                type: "int64",
                id: 1,
            },
            outskirt: {
                rule: "repeated",
                type: "OutskirtParam",
                id: 2,
            },
        },
    },
    PackagePurchaseInfoRequest: {
        fields: {
            playerId: {
                type: "int64",
                id: 1,
            },
            packageIds: {
                rule: "repeated",
                type: "int32",
                id: 2,
            },
        },
    },
    PackagePurchaseInfoResponse: {
        fields: {
            packages: {
                rule: "repeated",
                type: "ItemParam",
                id: 1,
            },
        },
    },
    PendingInventoryInfoRequest: {
        fields: {
            playerId: {
                type: "int64",
                id: 1,
            },
        },
    },
    PendingInventoryInfoResponse: {
        fields: {
            pending: {
                rule: "repeated",
                type: "PendingInventoryParam",
                id: 1,
            },
        },
    },
    PlayerInfoRequest: {
        fields: {
            playerId: {
                type: "int64",
                id: 1,
            },
        },
    },
    PlayerInfoResponse: {
        fields: {
            playerId: {
                type: "int64",
                id: 1,
            },
            coopId: {
                type: "int64",
                id: 2,
            },
            name: {
                type: "string",
                id: 3,
            },
            xp: {
                type: "int64",
                id: 4,
            },
            level: {
                type: "int32",
                id: 5,
            },
            profilePictureId: {
                type: "int32",
                id: 10,
            },
            buff: {
                rule: "repeated",
                type: "BuffParam",
                id: 11,
            },
            research: {
                rule: "repeated",
                type: "ResearchParam",
                id: 12,
            },
            adventurerXp: {
                type: "int64",
                id: 16,
            },
            adventurerLevel: {
                type: "int32",
                id: 17,
            },
            inviteEnable: {
                type: "bool",
                id: 18,
            },
            tmpActionRemainingTime: {
                type: "int32",
                id: 19,
            },
            secondsUntilCoopProjectAccess: {
                type: "int32",
                id: 20,
            },
        },
    },
    PlayerLeagueInfoRequest: {
        fields: {
            playerId: {
                type: "int64",
                id: 1,
            },
            eventId: {
                type: "int32",
                id: 2,
            },
        },
    },
    PlayerLeagueInfoResponse: {
        fields: {
            playerId: {
                type: "int64",
                id: 1,
            },
            leagueId: {
                type: "int32",
                id: 2,
            },
            leagueXp: {
                type: "int64",
                id: 3,
            },
            eventProgress: {
                type: "LeagueEventProgressParam",
                id: 4,
            },
        },
    },
    PlayerLeagueRankingRequest: {
        fields: {
            playerId: {
                type: "int64",
                id: 1,
            },
            eventId: {
                type: "int32",
                id: 2,
            },
        },
    },
    PlayerLeagueRankingResponse: {
        fields: {
            eventId: {
                type: "int32",
                id: 1,
            },
            leagueId: {
                type: "int32",
                id: 2,
            },
            rankingEntry: {
                rule: "repeated",
                type: "LeagueRankingParam",
                id: 3,
            },
        },
    },
    PlayerProfileInfoRequest: {
        fields: {
            playerId: {
                type: "int64",
                id: 1,
            },
        },
    },
    PlayerProfileInfoResponse: {
        fields: {
            playerId: {
                type: "int64",
                id: 1,
            },
            name: {
                type: "string",
                id: 2,
            },
            xp: {
                type: "int64",
                id: 3,
            },
            level: {
                type: "int32",
                id: 4,
            },
            profilePictureId: {
                type: "int32",
                id: 5,
            },
            playerLeagueId: {
                type: "int32",
                id: 6,
            },
            coopId: {
                type: "int64",
                id: 7,
            },
            coopName: {
                type: "string",
                id: 8,
            },
            coopXp: {
                type: "int64",
                id: 9,
            },
            coopLevel: {
                type: "int32",
                id: 10,
            },
            coopLeagueId: {
                type: "int32",
                id: 11,
            },
            invitable: {
                type: "bool",
                id: 12,
            },
            pvpLeagueId: {
                type: "int32",
                id: 13,
            },
            collectLeagueId: {
                type: "int32",
                id: 14,
            },
        },
    },
    PlayerSettingsInfoRequest: {
        fields: {
            playerId: {
                type: "int64",
                id: 1,
            },
        },
    },
    PlayerSettingsInfoResponse: {
        fields: {
            disableInvites: {
                type: "bool",
                id: 1,
            },
            mobileTrackingId: {
                type: "string",
                id: 2,
            },
        },
    },
    ProductionEffectItemInfoRequest: {
        fields: {
            playerId: {
                type: "int64",
                id: 1,
            },
            farmId: {
                type: "int32",
                id: 2,
            },
            buildingId: {
                type: "int32",
                id: 3,
            },
        },
    },
    ProductionEffectItemInfoResponse: {
        fields: {
            effectItemIds: {
                rule: "repeated",
                type: "int32",
                id: 1,
            },
        },
    },
    ProductionInfoRequest: {
        fields: {
            playerId: {
                type: "int64",
                id: 1,
            },
        },
    },
    ProductionInfoResponse: {
        fields: {
            playerId: {
                type: "int64",
                id: 1,
            },
            productions: {
                rule: "repeated",
                type: "ProductionParam",
                id: 2,
            },
        },
    },
    PurchasePointInfoRequest: {
        fields: {
            playerId: {
                type: "int64",
                id: 1,
            },
        },
    },
    PurchasePointInfoResponse: {
        fields: {
            playerId: {
                type: "int64",
                id: 1,
            },
            points: {
                type: "int64",
                id: 2,
            },
        },
    },
    PvpLeagueInfoRequest: {
        fields: {
            playerId: {
                type: "int64",
                id: 1,
            },
            eventId: {
                type: "int32",
                id: 2,
            },
        },
    },
    PvpLeagueInfoResponse: {
        fields: {
            playerId: {
                type: "int64",
                id: 1,
            },
            leagueId: {
                type: "int32",
                id: 2,
            },
            leagueXp: {
                type: "int64",
                id: 3,
            },
            unitAmount: {
                type: "int64",
                id: 4,
            },
            eventProgress: {
                type: "LeagueEventProgressParam",
                id: 5,
            },
        },
    },
    PvpLeagueRankingRequest: {
        fields: {
            playerId: {
                type: "int64",
                id: 1,
            },
            eventId: {
                type: "int32",
                id: 2,
            },
        },
    },
    PvpLeagueRankingResponse: {
        fields: {
            eventId: {
                type: "int32",
                id: 1,
            },
            leagueId: {
                type: "int32",
                id: 2,
            },
            rankingEntry: {
                rule: "repeated",
                type: "LeagueRankingParam",
                id: 3,
            },
        },
    },
    QuestInfoRequest: {
        fields: {
            playerId: {
                type: "int64",
                id: 1,
            },
        },
    },
    QuestInfoResponse: {
        fields: {
            quest: {
                rule: "repeated",
                type: "QuestParam",
                id: 1,
            },
        },
    },
    ShiftLevelInfoRequest: {
        fields: {
            playerId: {
                type: "int64",
                id: 1,
            },
        },
    },
    ShiftLevelInfoResponse: {
        fields: {
            shiftLevel: {
                type: "int32",
                id: 1,
            },
            remainingSeconds: {
                type: "int32",
                id: 2,
            },
        },
    },
    SubscriptionChangeInfoRequest: {
        fields: {
            playerId: {
                type: "int64",
                id: 1,
            },
            orderId: {
                type: "string",
                id: 2,
            },
        },
    },
    SubscriptionChangeInfoResponse: {
        fields: {
            changedSubscription: {
                rule: "repeated",
                type: "SubscriptionParam",
                id: 1,
            },
            unlockedPackage: {
                rule: "repeated",
                type: "UnlockedPackage",
                id: 2,
            },
        },
    },
    SubscriptionInfoRequest: {
        fields: {
            playerId: {
                type: "int64",
                id: 1,
            },
        },
    },
    SubscriptionInfoResponse: {
        fields: {
            trialDisabledSubscriptionId: {
                rule: "repeated",
                type: "int32",
                id: 1,
            },
            subscriptions: {
                rule: "repeated",
                type: "SubscriptionParam",
                id: 2,
            },
        },
    },
    TraderInfoRequest: {
        fields: {
            playerId: {
                type: "int64",
                id: 1,
            },
        },
    },
    TraderInfoResponse: {
        fields: {
            playerId: {
                type: "int64",
                id: 1,
            },
            trade: {
                rule: "repeated",
                type: "TradeParam",
                id: 2,
            },
            reward: {
                rule: "repeated",
                type: "ItemParam",
                id: 3,
            },
            eventId: {
                type: "int32",
                id: 4,
            },
            rewardPoints: {
                type: "int32",
                id: 5,
            },
        },
    },
    VisitOtherFarmInfoRequest: {
        fields: {
            playerId: {
                type: "int64",
                id: 1,
            },
            farmId: {
                type: "int32",
                id: 2,
            },
            includeHappinessMachine: {
                type: "bool",
                id: 100,
            },
        },
    },
    VisitOtherFarmInfoResponse: {
        fields: {
            playerInfoResponse: {
                type: "PlayerInfoResponse",
                id: 1,
            },
            farmInfoResponse: {
                type: "FarmInfoResponse",
                id: 2,
            },
            outskirtsInfoResponse: {
                type: "OutskirtsInfoResponse",
                id: 3,
            },
            productionInfoResponse: {
                type: "ProductionInfoResponse",
                id: 4,
            },
        },
    },
    LoginNotificationServerRequest: {
        fields: {
            playerId: {
                type: "int64",
                id: 1,
            },
            authenticationToken: {
                type: "string",
                id: 2,
            },
        },
    },
    LoginNotificationServerResponse: {
        fields: {
            authenticationToken: {
                type: "string",
                id: 1,
            },
        },
    },
    ReloadScheduledEventsNotification: {
        fields: {},
    },
    UpcomingMaintenance: {
        fields: {
            remainingSeconds: {
                type: "int32",
                id: 1,
            },
        },
    },
    BuyLibraryImprovementRequest: {
        fields: {
            playerId: {
                type: "int64",
                id: 1,
            },
            improvementId: {
                type: "int32",
                id: 2,
            },
            useHardCurrency: {
                type: "bool",
                id: 3,
            },
        },
    },
    BuyLibraryImprovementResponse: {
        fields: {
            improvement: {
                type: "ImprovementParam",
                id: 1,
            },
            buff: {
                rule: "repeated",
                type: "BuffParam",
                id: 2,
            },
            cost: {
                rule: "repeated",
                type: "ItemParam",
                id: 3,
            },
        },
    },
    BuyMarketImprovementRequest: {
        fields: {
            playerId: {
                type: "int64",
                id: 1,
            },
            improvementId: {
                type: "int32",
                id: 2,
            },
            useHardCurrency: {
                type: "bool",
                id: 3,
            },
        },
    },
    BuyMarketImprovementResponse: {
        fields: {
            improvement: {
                type: "ImprovementParam",
                id: 1,
            },
            buff: {
                rule: "repeated",
                type: "BuffParam",
                id: 2,
            },
            cost: {
                rule: "repeated",
                type: "ItemParam",
                id: 3,
            },
        },
    },
    BuyPierImprovementRequest: {
        fields: {
            playerId: {
                type: "int64",
                id: 1,
            },
            improvementId: {
                type: "int32",
                id: 2,
            },
            useHardCurrency: {
                type: "bool",
                id: 3,
            },
        },
    },
    BuyPierImprovementResponse: {
        fields: {
            improvement: {
                type: "ImprovementParam",
                id: 1,
            },
            buff: {
                rule: "repeated",
                type: "BuffParam",
                id: 2,
            },
            cost: {
                rule: "repeated",
                type: "ItemParam",
                id: 3,
            },
        },
    },
    CatchFishRequest: {
        fields: {
            playerId: {
                type: "int64",
                id: 1,
            },
            baitId: {
                type: "int32",
                id: 2,
            },
        },
    },
    CatchFishResponse: {
        fields: {
            weightInGram: {
                type: "int32",
                id: 1,
            },
            fishId: {
                type: "int32",
                id: 2,
            },
            highScore: {
                type: "bool",
                id: 3,
            },
            baitCost: {
                rule: "repeated",
                type: "ItemParam",
                id: 4,
            },
            baitId: {
                type: "int32",
                id: 5,
            },
            newFish: {
                type: "bool",
                id: 6,
            },
        },
    },
    CollectWaterRequest: {
        fields: {
            playerId: {
                type: "int64",
                id: 1,
            },
        },
    },
    CollectWaterResponse: {
        fields: {
            watertower: {
                type: "OutskirtParam",
                id: 1,
            },
            xp: {
                type: "int64",
                id: 2,
            },
            product: {
                rule: "repeated",
                type: "ItemParam",
                id: 3,
            },
            adventurerXp: {
                type: "int64",
                id: 4,
            },
        },
    },
    ExchangeFreeTreatPointsRequest: {
        fields: {
            playerId: {
                type: "int64",
                id: 1,
            },
            amount: {
                type: "int32",
                id: 2,
            },
        },
    },
    ExchangeFreeTreatPointsResponse: {
        fields: {
            dogOutSkirt: {
                type: "OutskirtParam",
                id: 1,
            },
            product: {
                type: "ItemParam",
                id: 2,
            },
        },
    },
    ProduceAndCollectOutskirtRequest: {
        fields: {
            playerId: {
                type: "int64",
                id: 1,
            },
            typeId: {
                type: "int32",
                id: 2,
            },
            recipeId: {
                type: "int32",
                id: 3,
            },
        },
    },
    ProduceAndCollectOutskirtResponse: {
        fields: {
            outskirt: {
                type: "OutskirtParam",
                id: 1,
            },
            cost: {
                rule: "repeated",
                type: "ItemParam",
                id: 2,
            },
            playerXp: {
                type: "int64",
                id: 3,
            },
            adventurerXp: {
                type: "int64",
                id: 4,
            },
            satisfaction: {
                type: "int32",
                id: 5,
            },
            totalSatisfaction: {
                type: "int32",
                id: 6,
            },
            product: {
                rule: "repeated",
                type: "ItemParam",
                id: 7,
            },
        },
    },
    SellFishRequest: {
        fields: {
            playerId: {
                type: "int64",
                id: 1,
            },
        },
    },
    SellFishResponse: {
        fields: {
            itemId: {
                type: "int32",
                id: 1,
            },
            amount: {
                type: "int32",
                id: 2,
            },
            earnings: {
                rule: "repeated",
                type: "ItemParam",
                id: 3,
            },
        },
    },
    StartFarmMachineRequest: {
        fields: {
            playerId: {
                type: "int64",
                id: 1,
            },
            farmMachineId: {
                type: "int32",
                id: 2,
            },
            fuelId: {
                type: "int32",
                id: 3,
            },
            amount: {
                type: "int32",
                id: 4,
            },
        },
    },
    StartFarmMachineResponse: {
        fields: {
            buff: {
                rule: "repeated",
                type: "BuffParam",
                id: 1,
            },
            cost: {
                rule: "repeated",
                type: "ItemParam",
                id: 2,
            },
        },
    },
    UpgradeOutskirtRequest: {
        fields: {
            playerId: {
                type: "int64",
                id: 1,
            },
            typeId: {
                type: "int32",
                id: 2,
            },
        },
    },
    UpgradeOutskirtResponse: {
        fields: {
            upgrade: {
                type: "OutskirtParam",
                id: 1,
            },
            cost: {
                rule: "repeated",
                type: "ItemParam",
                id: 2,
            },
            modifiedBuff: {
                type: "BuffParam",
                id: 3,
            },
        },
    },
    BuyDogPackageRequest: {
        fields: {
            playerId: {
                type: "int64",
                id: 1,
            },
            packageId: {
                type: "int32",
                id: 2,
            },
        },
    },
    BuyDogPackageResponse: {
        fields: {},
    },
    BuyPackageRequest: {
        fields: {
            playerId: {
                type: "int64",
                id: 1,
            },
            packageId: {
                type: "int32",
                id: 2,
            },
            amount: {
                type: "int32",
                id: 3,
            },
            eventId: {
                type: "int32",
                id: 4,
            },
        },
    },
    BuyPackageResponse: {
        fields: {},
    },
    ConsumeDogPackageBonusRequest: {
        fields: {
            playerId: {
                type: "int64",
                id: 1,
            },
        },
    },
    ConsumeDogPackageBonusResponse: {
        fields: {},
    },
    ConsumePackageRequest: {
        fields: {
            playerId: {
                type: "int64",
                id: 1,
            },
            packageId: {
                type: "int32",
                id: 2,
            },
            amount: {
                type: "int32",
                id: 3,
            },
        },
    },
    ConsumePackageResponse: {
        fields: {},
    },
    ConsumePendingInventoryRequest: {
        fields: {
            playerId: {
                type: "int64",
                id: 1,
            },
            transferId: {
                rule: "repeated",
                type: "int64",
                id: 2,
            },
        },
    },
    ConsumePendingInventoryResponse: {
        fields: {
            resource: {
                rule: "repeated",
                type: "ItemParam",
                id: 1,
            },
            building: {
                rule: "repeated",
                type: "ItemParam",
                id: 2,
            },
            package: {
                rule: "repeated",
                type: "ItemParam",
                id: 3,
            },
            picture: {
                rule: "repeated",
                type: "ItemParam",
                id: 4,
            },
        },
    },
    ConsumeUnlockedPackageRequest: {
        fields: {
            playerId: {
                type: "int64",
                id: 1,
            },
            packageId: {
                type: "int32",
                id: 2,
            },
        },
    },
    ConsumeUnlockedPackageResponse: {
        fields: {
            packageId: {
                type: "int32",
                id: 1,
            },
        },
    },
    UnlockedPackageInfoRequest: {
        fields: {},
    },
    UnlockedPackageInfoResponse: {
        fields: {
            package: {
                rule: "repeated",
                type: "UnlockedPackage",
                id: 1,
            },
        },
    },
    UnlockLoginPackageRequest: {
        fields: {},
    },
    UnlockLoginPackageResponse: {
        fields: {
            package: {
                rule: "repeated",
                type: "UnlockedPackage",
                id: 1,
            },
        },
    },
    FinishTransactionRequest: {
        fields: {
            playerId: {
                type: "uint64",
                id: 1,
            },
            transactionId: {
                type: "string",
                id: 2,
            },
            paymentProvider: {
                type: "string",
                id: 3,
            },
        },
    },
    FinishTransactionResponse: {
        fields: {
            numberOfPaymentsYet: {
                type: "int32",
                id: 1,
            },
        },
    },
    MapPlayerSubscriptionRequest: {
        fields: {
            playerId: {
                type: "int64",
                id: 1,
            },
            shop: {
                type: "Shop",
                id: 2,
            },
            receiptId: {
                type: "string",
                id: 3,
            },
        },
    },
    MapPlayerSubscriptionResponse: {
        fields: {},
    },
    OpenTransactionListRequest: {
        fields: {
            playerId: {
                type: "uint64",
                id: 1,
            },
            paymentProvider: {
                type: "string",
                id: 2,
            },
        },
    },
    OpenTransactionListResponse: {
        fields: {
            responseCode: {
                type: "int32",
                id: 1,
            },
            transactions: {
                rule: "repeated",
                type: "string",
                id: 2,
            },
        },
    },
    PaymentEntryInfoRequest: {
        fields: {
            playerId: {
                type: "int64",
                id: 1,
            },
            offerCharacteristicId: {
                rule: "repeated",
                type: "int32",
                id: 2,
            },
        },
    },
    PaymentEntryInfoResponse: {
        fields: {
            offers: {
                rule: "repeated",
                type: "ItemParam",
                id: 1,
            },
            timeSinceSeasonPassPaymentInSeconds: {
                type: "int32",
                id: 2,
            },
        },
    },
    PaymentPackageListRequest: {
        fields: {
            playerId: {
                type: "uint64",
                id: 1,
            },
            paymentProvider: {
                type: "string",
                id: 2,
            },
        },
    },
    PaymentPackageListResponse: {
        fields: {
            errorCode: {
                type: "int32",
                id: 1,
            },
            packageListJson: {
                type: "string",
                id: 2,
            },
        },
    },
    UpdatePaymentEntryRequest: {
        fields: {
            playerId: {
                type: "int64",
                id: 1,
            },
            offerCharacteristicId: {
                type: "int32",
                id: 2,
            },
        },
    },
    UpdatePaymentEntryResponse: {
        fields: {
            amount: {
                type: "int32",
                id: 1,
            },
        },
    },
    VerifyPaymentReceiptRequest: {
        fields: {
            playerId: {
                type: "uint64",
                id: 1,
            },
            paymentProvider: {
                type: "string",
                id: 2,
            },
            receipt: {
                type: "string",
                id: 3,
            },
            purchaseOfferNameId: {
                type: "string",
                id: 4,
            },
            purchaseOfferCharacteristicId: {
                type: "uint32",
                id: 5,
            },
        },
    },
    VerifyPaymentReceiptResponse: {
        fields: {
            responseCode: {
                type: "int32",
                id: 1,
            },
            phpResponse: {
                type: "string",
                id: 2,
            },
        },
    },
    VerifySubscriptionReceiptRequest: {
        fields: {
            receiptId: {
                type: "string",
                id: 1,
            },
            receipt: {
                type: "string",
                id: 2,
            },
        },
    },
    VerifySubscriptionReceiptResponse: {
        fields: {},
    },
    WebShopCatalogRequest: {
        fields: {
            playerId: {
                type: "uint64",
                id: 1,
            },
            language: {
                type: "string",
                id: 2,
            },
        },
    },
    WebShopCatalogResponse: {
        fields: {
            packages: {
                rule: "repeated",
                type: "WebShopPackage",
                id: 1,
            },
            providers: {
                rule: "repeated",
                type: "WebShopProvider",
                id: 2,
            },
            smsPackages: {
                rule: "repeated",
                type: "WebShopSmsPackage",
                id: 3,
            },
        },
    },
    WebShopCheckoutRequest: {
        fields: {
            playerId: {
                type: "int64",
                id: 1,
            },
            purchaseOfferCharacteristicId: {
                type: "int32",
                id: 2,
            },
            purchaseOfferNameId: {
                type: "string",
                id: 3,
            },
            description: {
                type: "string",
                id: 4,
            },
            itemId: {
                type: "int64",
                id: 5,
            },
            providerId: {
                type: "int32",
                id: 6,
            },
            locale: {
                type: "string",
                id: 7,
            },
            shopStepCount: {
                type: "int32",
                id: 8,
            },
            shopSessionId: {
                type: "int32",
                id: 9,
            },
            shopId: {
                type: "int32",
                id: 10,
            },
        },
    },
    WebShopCheckoutResponse: {
        fields: {
            checkoutURL: {
                type: "string",
                id: 1,
            },
        },
    },
    ChoosePlayerProfilePictureRequest: {
        fields: {
            playerId: {
                type: "int64",
                id: 1,
            },
            newPlayerProfilePictureId: {
                type: "int32",
                id: 2,
            },
        },
    },
    ChoosePlayerProfilePictureResponse: {
        fields: {},
    },
    CollectLoginRewardRequest: {
        fields: {
            playerId: {
                type: "int64",
                id: 1,
            },
        },
    },
    CollectLoginRewardResponse: {
        fields: {
            remainingSecondsUntilNextReward: {
                type: "int32",
                id: 1,
            },
            rewardedPackage: {
                rule: "repeated",
                type: "ItemParam",
                id: 2,
            },
        },
    },
    PlayerCancelInviteRequest: {
        fields: {
            playerId: {
                type: "int64",
                id: 1,
            },
        },
    },
    PlayerCancelInviteResponse: {
        fields: {},
    },
    PlayerChangeSettingsRequest: {
        fields: {
            playerId: {
                type: "int64",
                id: 1,
            },
            disableInvites: {
                type: "bool",
                id: 2,
            },
            mobileTrackingId: {
                type: "string",
                id: 3,
            },
        },
    },
    PlayerChangeSettingsResponse: {
        fields: {
            disableInvites: {
                type: "bool",
                id: 1,
            },
            mobileTrackingId: {
                type: "string",
                id: 2,
            },
        },
    },
    PlayerInviteInfoRequest: {
        fields: {
            playerId: {
                type: "int64",
                id: 1,
            },
        },
    },
    PlayerInviteInfoResponse: {
        fields: {
            activeInvite: {
                rule: "repeated",
                type: "CoopInviteParam",
                id: 1,
            },
        },
    },
    PlayerPreferencesStorageRequest: {
        fields: {
            playerId: {
                type: "int64",
                id: 1,
            },
            keyValuesAddOrReplace: {
                rule: "repeated",
                type: "PlayerPreferencesParam",
                id: 2,
            },
            keysToRemove: {
                rule: "repeated",
                type: "PlayerPreferencesKeyParam",
                id: 3,
            },
        },
    },
    PlayerPreferencesStorageResponse: {
        fields: {
            keyValues: {
                rule: "repeated",
                type: "PlayerPreferencesParam",
                id: 1,
            },
        },
    },
    BoostProduceRequest: {
        fields: {
            playerId: {
                type: "int64",
                id: 1,
            },
            farmId: {
                type: "int32",
                id: 2,
            },
            buildingId: {
                type: "int32",
                id: 3,
            },
            boostId: {
                type: "int32",
                id: 4,
            },
        },
    },
    BoostProduceResponse: {
        fields: {
            farmId: {
                type: "int32",
                id: 1,
            },
            buildingId: {
                type: "int32",
                id: 2,
            },
            xp: {
                type: "int64",
                id: 3,
            },
            production: {
                type: "ProductionParam",
                id: 4,
            },
            adventurerXp: {
                type: "int64",
                id: 5,
            },
        },
    },
    BuyProductsRequest: {
        fields: {
            playerId: {
                type: "int64",
                id: 1,
            },
            itemId: {
                type: "int32",
                id: 2,
            },
            amount: {
                type: "int32",
                id: 3,
            },
        },
    },
    BuyProductsResponse: {
        fields: {
            itemId: {
                type: "int32",
                id: 1,
            },
            amount: {
                type: "int32",
                id: 2,
            },
            cost: {
                rule: "repeated",
                type: "ItemParam",
                id: 3,
            },
        },
    },
    BuyProductsGoldRequest: {
        fields: {
            playerId: {
                type: "int64",
                id: 1,
            },
            items: {
                rule: "repeated",
                type: "ItemParam",
                id: 2,
            },
        },
    },
    BuyProductsGoldResponse: {
        fields: {
            items: {
                rule: "repeated",
                type: "ItemParam",
                id: 1,
            },
            cost: {
                rule: "repeated",
                type: "ItemParam",
                id: 2,
            },
        },
    },
    BuyResearchRequest: {
        fields: {
            playerId: {
                type: "int64",
                id: 1,
            },
            researchId: {
                type: "int32",
                id: 2,
            },
        },
    },
    BuyResearchResponse: {
        fields: {
            research: {
                type: "ResearchParam",
                id: 1,
            },
            buff: {
                rule: "repeated",
                type: "BuffParam",
                id: 2,
            },
            cost: {
                rule: "repeated",
                type: "ItemParam",
                id: 3,
            },
        },
    },
    CancelProductionRequest: {
        fields: {
            playerId: {
                type: "int64",
                id: 1,
            },
            farmId: {
                type: "int32",
                id: 2,
            },
            buildingId: {
                type: "int32",
                id: 3,
            },
        },
    },
    CancelProductionResponse: {
        fields: {},
    },
    CollectProductsRequest: {
        fields: {
            playerId: {
                type: "int64",
                id: 1,
            },
            farmId: {
                type: "int32",
                id: 2,
            },
            buildingId: {
                type: "int32",
                id: 3,
            },
        },
    },
    CollectProductsResponse: {
        fields: {
            farmId: {
                type: "int32",
                id: 1,
            },
            buildingId: {
                type: "int32",
                id: 2,
            },
            xp: {
                type: "int64",
                id: 3,
            },
            product: {
                rule: "repeated",
                type: "ItemParam",
                id: 4,
            },
            adventurerXp: {
                type: "int64",
                id: 5,
            },
        },
    },
    DonateResourceRequest: {
        fields: {
            playerId: {
                type: "int64",
                id: 1,
            },
            itemId: {
                type: "int32",
                id: 2,
            },
            amount: {
                type: "int32",
                id: 3,
            },
        },
    },
    DonateResourceResponse: {
        fields: {
            itemId: {
                type: "int32",
                id: 1,
            },
            amount: {
                type: "int32",
                id: 2,
            },
        },
    },
    SellProductsRequest: {
        fields: {
            playerId: {
                type: "int64",
                id: 1,
            },
            itemId: {
                type: "int32",
                id: 2,
            },
            amount: {
                type: "int32",
                id: 3,
            },
        },
    },
    SellProductsResponse: {
        fields: {
            itemId: {
                type: "int32",
                id: 1,
            },
            amount: {
                type: "int32",
                id: 2,
            },
            earnings: {
                rule: "repeated",
                type: "ItemParam",
                id: 3,
            },
        },
    },
    SkipProduceRequest: {
        fields: {
            playerId: {
                type: "int64",
                id: 1,
            },
            farmId: {
                type: "int32",
                id: 2,
            },
            buildingId: {
                type: "int32",
                id: 3,
            },
            itemId: {
                type: "int32",
                id: 4,
            },
            amount: {
                type: "int64",
                id: 5,
            },
        },
    },
    SkipProduceResponse: {
        fields: {
            farmId: {
                type: "int32",
                id: 1,
            },
            buildingId: {
                type: "int32",
                id: 2,
            },
            itemId: {
                type: "int32",
                id: 3,
            },
            amount: {
                type: "int64",
                id: 4,
            },
        },
    },
    StartProduceRequest: {
        fields: {
            playerId: {
                type: "int64",
                id: 1,
            },
            farmId: {
                type: "int32",
                id: 2,
            },
            buildingId: {
                type: "int32",
                id: 3,
            },
            recipeId: {
                type: "int32",
                id: 4,
            },
            amount: {
                type: "int32",
                id: 5,
            },
            effectItemIds: {
                rule: "repeated",
                type: "int32",
                id: 6,
            },
        },
    },
    StartProduceResponse: {
        fields: {
            farmId: {
                type: "int32",
                id: 1,
            },
            buildingId: {
                type: "int32",
                id: 2,
            },
            xp: {
                type: "int64",
                id: 3,
            },
            cost: {
                rule: "repeated",
                type: "ItemParam",
                id: 4,
            },
            production: {
                type: "ProductionParam",
                id: 5,
            },
        },
    },
    PvpMapAttackRequest: {
        fields: {
            playerId: {
                type: "int64",
                id: 1,
            },
            eventId: {
                type: "int32",
                id: 2,
            },
            tileId: {
                type: "int32",
                id: 3,
            },
            unitAmount: {
                type: "int64",
                id: 4,
            },
        },
    },
    PvpMapAttackResponse: {
        fields: {
            attackerWon: {
                type: "bool",
                id: 1,
            },
        },
    },
    PvpMapInfoRequest: {
        fields: {
            playerId: {
                type: "int64",
                id: 1,
            },
            eventId: {
                type: "int32",
                id: 2,
            },
        },
    },
    PvpMapInfoResponse: {
        fields: {
            tile: {
                rule: "repeated",
                type: "PvpMapTile",
                id: 1,
            },
            player: {
                rule: "repeated",
                type: "PvpMapPlayerInfo",
                id: 2,
            },
        },
    },
    PvpMapJoinRequest: {
        fields: {
            playerId: {
                type: "int64",
                id: 1,
            },
            eventId: {
                type: "int32",
                id: 2,
            },
        },
    },
    PvpMapJoinResponse: {
        fields: {},
    },
    PvpMapNotificationRequest: {
        fields: {
            playerId: {
                type: "int64",
                id: 1,
            },
            tileId: {
                type: "int32",
                id: 2,
            },
            eventId: {
                type: "int32",
                id: 3,
            },
            updatedPlayerIds: {
                rule: "repeated",
                type: "int64",
                id: 4,
            },
        },
    },
    PvpMapNotificationResponse: {
        fields: {
            tile: {
                rule: "repeated",
                type: "PvpMapTile",
                id: 1,
            },
            player: {
                rule: "repeated",
                type: "PvpMapPlayerInfo",
                id: 2,
            },
        },
    },
    PvpMapReinforceRequest: {
        fields: {
            playerId: {
                type: "int64",
                id: 1,
            },
            eventId: {
                type: "int32",
                id: 2,
            },
            tileId: {
                type: "int32",
                id: 3,
            },
            unitAmount: {
                type: "int64",
                id: 4,
            },
        },
    },
    PvpMapReinforceResponse: {
        fields: {},
    },
    CompleteQuestStateRequest: {
        fields: {
            playerId: {
                type: "int64",
                id: 1,
            },
            questId: {
                type: "int32",
                id: 2,
            },
        },
    },
    CompleteQuestStateResponse: {
        fields: {
            quest: {
                type: "QuestParam",
                id: 1,
            },
        },
    },
    DismissContractRequest: {
        fields: {
            playerId: {
                type: "int64",
                id: 1,
            },
            farmId: {
                type: "int32",
                id: 2,
            },
            contractId: {
                type: "int32",
                id: 3,
            },
        },
    },
    DismissContractResponse: {
        fields: {
            farmId: {
                type: "int32",
                id: 1,
            },
            contractId: {
                type: "int32",
                id: 2,
            },
            contract: {
                rule: "repeated",
                type: "ContractParam",
                id: 3,
            },
        },
    },
    FulfillContractRequest: {
        fields: {
            playerId: {
                type: "int64",
                id: 1,
            },
            farmId: {
                type: "int32",
                id: 2,
            },
            contractId: {
                type: "int32",
                id: 3,
            },
        },
    },
    FulfillContractResponse: {
        fields: {
            farmId: {
                type: "int32",
                id: 1,
            },
            contractId: {
                type: "int32",
                id: 2,
            },
            contract: {
                rule: "repeated",
                type: "ContractParam",
                id: 3,
            },
            market: {
                type: "OutskirtParam",
                id: 4,
            },
            earnings: {
                rule: "repeated",
                type: "ItemParam",
                id: 5,
            },
        },
    },
    QuestFinishRequest: {
        fields: {
            playerId: {
                type: "int64",
                id: 1,
            },
            questId: {
                type: "int32",
                id: 2,
            },
        },
    },
    QuestFinishResponse: {
        fields: {
            questId: {
                type: "int32",
                id: 2,
            },
            quest: {
                rule: "repeated",
                type: "QuestParam",
                id: 3,
            },
        },
    },
    QuestStartRequest: {
        fields: {
            playerId: {
                type: "int64",
                id: 1,
            },
            questId: {
                type: "int32",
                id: 2,
            },
        },
    },
    QuestStartResponse: {
        fields: {
            quest: {
                type: "QuestParam",
                id: 1,
            },
        },
    },
    QuestUpdateRequest: {
        fields: {
            playerId: {
                type: "int64",
                id: 1,
            },
            questId: {
                rule: "repeated",
                type: "int32",
                id: 2,
            },
        },
    },
    QuestUpdateResponse: {
        fields: {
            quest: {
                rule: "repeated",
                type: "QuestParam",
                id: 1,
            },
        },
    },
    SkipContractRequest: {
        fields: {
            playerId: {
                type: "int64",
                id: 1,
            },
            farmId: {
                type: "int32",
                id: 2,
            },
            contractId: {
                type: "int32",
                id: 3,
            },
            itemId: {
                type: "int32",
                id: 4,
            },
            amount: {
                type: "int64",
                id: 5,
            },
        },
    },
    SkipContractResponse: {
        fields: {
            farmId: {
                type: "int32",
                id: 1,
            },
            contractId: {
                type: "int32",
                id: 2,
            },
            itemId: {
                type: "int32",
                id: 3,
            },
            amount: {
                type: "int64",
                id: 4,
            },
            contract: {
                rule: "repeated",
                type: "ContractParam",
                id: 5,
            },
        },
    },
    SkipQuestTaskRequest: {
        fields: {
            playerId: {
                type: "int64",
                id: 1,
            },
            questId: {
                type: "int32",
                id: 2,
            },
            taskIndex: {
                type: "int32",
                id: 3,
            },
            itemId: {
                type: "int32",
                id: 4,
            },
            amount: {
                type: "int64",
                id: 5,
            },
        },
    },
    SkipQuestTaskResponse: {
        fields: {
            quest: {
                type: "QuestParam",
                id: 1,
            },
            itemId: {
                type: "int32",
                id: 2,
            },
            amount: {
                type: "int64",
                id: 3,
            },
        },
    },
    StartQuestTreeEventRequest: {
        fields: {
            playerId: {
                type: "int64",
                id: 1,
            },
            eventId: {
                type: "int32",
                id: 2,
            },
            difficulty: {
                type: "int32",
                id: 3,
            },
        },
    },
    StartQuestTreeEventResponse: {
        fields: {
            eventId: {
                type: "int32",
                id: 1,
            },
            starterQuest: {
                type: "QuestParam",
                id: 2,
            },
        },
    },
    ThemedEventFinishRequest: {
        fields: {
            playerId: {
                type: "int64",
                id: 1,
            },
            eventId: {
                type: "int32",
                id: 2,
            },
        },
    },
    ThemedEventFinishResponse: {
        fields: {
            eventId: {
                type: "int32",
                id: 1,
            },
        },
    },
    ThemedEventStartRequest: {
        fields: {
            playerId: {
                type: "int64",
                id: 1,
            },
            eventId: {
                type: "int32",
                id: 2,
            },
            difficulty: {
                type: "int32",
                id: 3,
            },
        },
    },
    ThemedEventStartResponse: {
        fields: {
            eventId: {
                type: "int32",
                id: 1,
            },
            quest: {
                type: "QuestParam",
                id: 2,
            },
        },
    },
    UpdateCollectLeagueEventRequest: {
        fields: {
            playerId: {
                type: "int64",
                id: 1,
            },
            points: {
                type: "int64",
                id: 2,
            },
        },
    },
    UpdateCollectLeagueEventResponse: {
        fields: {
            eventId: {
                type: "int32",
                id: 1,
            },
            leagueId: {
                type: "int32",
                id: 2,
            },
            points: {
                type: "int64",
                id: 3,
            },
        },
    },
    UpdateLeagueEventRequest: {
        fields: {
            playerId: {
                type: "int64",
                id: 1,
            },
            points: {
                type: "int64",
                id: 2,
            },
        },
    },
    UpdateLeagueEventResponse: {
        fields: {
            eventId: {
                type: "int32",
                id: 1,
            },
            leagueId: {
                type: "int32",
                id: 2,
            },
            points: {
                type: "int64",
                id: 3,
            },
        },
    },
    UpdateLongTermPointEventRequest: {
        fields: {
            playerId: {
                type: "int64",
                id: 1,
            },
            points: {
                type: "int64",
                id: 2,
            },
            eventId: {
                type: "int32",
                id: 3,
            },
        },
    },
    UpdateLongTermPointEventResponse: {
        fields: {
            eventId: {
                type: "int32",
                id: 1,
            },
            points: {
                type: "int64",
                id: 2,
            },
        },
    },
    UpdatePurchasePointEventRequest: {
        fields: {
            playerId: {
                type: "int64",
                id: 1,
            },
            points: {
                type: "int64",
                id: 2,
            },
        },
    },
    UpdatePurchasePointEventResponse: {
        fields: {
            eventId: {
                type: "int32",
                id: 1,
            },
            points: {
                type: "int64",
                id: 2,
            },
        },
    },
    UpdatePvpLeagueEventRequest: {
        fields: {
            playerId: {
                type: "int64",
                id: 1,
            },
            points: {
                type: "int64",
                id: 2,
            },
        },
    },
    UpdatePvpLeagueEventResponse: {
        fields: {
            eventId: {
                type: "int32",
                id: 1,
            },
            leagueId: {
                type: "int32",
                id: 2,
            },
            points: {
                type: "int64",
                id: 3,
            },
        },
    },
    UpdateTraderEventRequest: {
        fields: {
            playerId: {
                type: "int64",
                id: 1,
            },
            points: {
                type: "int64",
                id: 2,
            },
        },
    },
    UpdateTraderEventResponse: {
        fields: {
            eventId: {
                type: "int32",
                id: 1,
            },
            points: {
                type: "int64",
                id: 2,
            },
        },
    },
    CollectFishFiletRequest: {
        fields: {
            playerId: {
                type: "int64",
                id: 1,
            },
            panId: {
                type: "int32",
                id: 2,
            },
        },
    },
    CollectFishFiletResponse: {
        fields: {
            panInfo: {
                type: "PanInfo",
                id: 1,
            },
            filet: {
                type: "ItemParam",
                id: 2,
            },
        },
    },
    CookFishRequest: {
        fields: {
            playerId: {
                type: "int64",
                id: 1,
            },
            panId: {
                type: "int32",
                id: 2,
            },
        },
    },
    CookFishResponse: {
        fields: {
            panInfo: {
                type: "PanInfo",
                id: 1,
            },
        },
    },
    CookingPansInfoRequest: {
        fields: {
            playerId: {
                type: "int64",
                id: 1,
            },
        },
    },
    CookingPansInfoResponse: {
        fields: {
            panInfos: {
                rule: "repeated",
                type: "PanInfo",
                id: 1,
            },
            unlockedPanAmount: {
                type: "int32",
                id: 2,
            },
        },
    },
    SkipCookingRequest: {
        fields: {
            playerId: {
                type: "int64",
                id: 1,
            },
            panId: {
                type: "int32",
                id: 2,
            },
            itemId: {
                type: "int32",
                id: 3,
            },
            amount: {
                type: "int64",
                id: 4,
            },
        },
    },
    SkipCookingResponse: {
        fields: {
            panInfo: {
                type: "PanInfo",
                id: 1,
            },
            itemId: {
                type: "int32",
                id: 2,
            },
            amount: {
                type: "int64",
                id: 3,
            },
        },
    },
    CollectCollectablePointRewardRequest: {
        fields: {
            eventId: {
                type: "int32",
                id: 1,
            },
            collectablePointRewardId: {
                type: "int32",
                id: 2,
            },
            pointRewardType: {
                type: "PointRewardType",
                id: 3,
            },
        },
    },
    CollectCollectablePointRewardResponse: {
        fields: {
            rewardedResource: {
                rule: "repeated",
                type: "ItemParam",
                id: 1,
            },
            rewardedBuilding: {
                rule: "repeated",
                type: "ItemParam",
                id: 2,
            },
            rewardedProfilePicture: {
                rule: "repeated",
                type: "ItemParam",
                id: 3,
            },
        },
    },
    GrantCoopRewardRequest: {
        fields: {
            playerId: {
                type: "int64",
                id: 1,
            },
            coopId: {
                type: "int64",
                id: 2,
            },
            sourceId: {
                type: "RewardSource",
                id: 3,
            },
            resource: {
                rule: "repeated",
                type: "ResourceRewardParam",
                id: 4,
            },
        },
    },
    GrantCoopRewardResponse: {
        fields: {},
    },
    GrantRewardRequest: {
        fields: {
            playerId: {
                type: "int64",
                id: 1,
            },
            paymentOfferId: {
                type: "string",
                id: 2,
            },
            paymentPackageId: {
                type: "string",
                id: 3,
            },
            paymentProvider: {
                type: "string",
                id: 4,
            },
            packageId: {
                type: "int32",
                id: 5,
            },
            packageAmount: {
                type: "int32",
                id: 6,
            },
            balloonOfferContentId: {
                type: "int32",
                id: 7,
            },
            balloonOfferLevel: {
                type: "int32",
                id: 8,
            },
            sourceId: {
                type: "RewardSource",
                id: 9,
            },
            resource: {
                rule: "repeated",
                type: "ResourceRewardParam",
                id: 10,
            },
            building: {
                rule: "repeated",
                type: "BuildingRewardParam",
                id: 11,
            },
            package: {
                rule: "repeated",
                type: "PackageRewardParam",
                id: 12,
            },
            profilePicture: {
                rule: "repeated",
                type: "ProfilePictureRewardParam",
                id: 13,
            },
            randomPool: {
                rule: "repeated",
                type: "RandomPoolRewardParam",
                id: 14,
            },
            randomPoolSeed: {
                type: "int32",
                id: 15,
            },
            orderId: {
                type: "string",
                id: 16,
            },
            unlockable: {
                rule: "repeated",
                type: "UnlockableRewardParam",
                id: 17,
            },
        },
    },
    GrantRewardResponse: {
        fields: {
            packageId: {
                type: "int32",
                id: 1,
            },
            packageAmount: {
                type: "int32",
                id: 2,
            },
            sourceId: {
                type: "RewardSource",
                id: 3,
            },
            resourceRewards: {
                rule: "repeated",
                type: "ItemParam",
                id: 4,
            },
            buildingRewards: {
                rule: "repeated",
                type: "ItemParam",
                id: 5,
            },
            packageRewards: {
                rule: "repeated",
                type: "ItemParam",
                id: 6,
            },
            profilePictureRewards: {
                rule: "repeated",
                type: "ItemParam",
                id: 7,
            },
            duplicatedProfilePictureRewards: {
                rule: "repeated",
                type: "ItemParam",
                id: 8,
            },
            convertedSnippetsFromProfilePicture: {
                rule: "repeated",
                type: "ItemParam",
                id: 9,
            },
            paymentOfferId: {
                type: "string",
                id: 20,
            },
            unlockable: {
                rule: "repeated",
                type: "ItemParam",
                id: 21,
            },
        },
    },
});
export var proto = $root;



//////////////////
// WEBPACK FOOTER
// ./src/utils/network/generated/proto.ts
// module id = 970
// module chunks = 3